let swymInstance,
  currentWishlistProduct,
  currentWishlistButton,
  customerLists = [],
  originalSelections = new Set(),
  selectedLists = new Set(),
  pendingNewList = null,
  pendingRemoveList = null,
  listsToAdd = [],
  listsToRemove = [],
  wishlistCartTokenPromise = null,
  currentDrawerList = null,
  currentDrawerSwat = null,
  currentDrawerLid = null,
  currentDrawerLname = null,
  currentEditList = null,
  currentShareList = null,
  wishlistRequestToken = 0,
  currentWishlistPreparedData = {
    lid: null,
    ready: false,
    items: [],
    customizationItems: [],
    outOfStockItems: [],
    addableItems: []
  };
var wishlistTranslations = {};
var wishlistTranslationsEl = document.getElementById('wishlist-translations');
if (wishlistTranslationsEl) {
  try {
    wishlistTranslations = JSON.parse(
      wishlistTranslationsEl.textContent
    );
  } catch (error) {
    console.error('[Wishlist] Failed to parse translations:', error);
  }
}
(function () {
  "use strict";
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlist);
  /**
  * Initializes the wishlist functionality once Swym is ready.
  * Loads customer wishlist lists and initializes all wishlist components.
  */
  function initWishlist(swat) {
    swymInstance = swat;
    loadCustomerLists(function () {
      initHeaderIconCount(swat);
      initHeaderIcon(swat)
      initPDPButton(swat);
      initProductCardButtons(swat);
      observeCollectionWishlistButtons();
      bindGlobalVariantChange(swat);
      initWishlistPage(swat);
    });
    initSharedWishlistPage(swat);
  }
  /**
  * Fetches all wishlist lists for the current customer.
  * Stores the retrieved lists globally in customerLists.
  */
  function loadCustomerLists(callback) {
    swymInstance.fetchLists({
      callbackFn: function (lists) {
        customerLists = lists || [];

        if (typeof callback === "function") {
          callback();
        }
      },
      errorFn: function (error) {
        console.error("fetchLists error:", error);

        if (typeof callback === "function") {
          callback();
        }
      }
    });
  }
  /**
  * Initializes the PDP wishlist button.
  * Builds the current product object, checks its wishlist state,
  * and opens the wishlist modal when the button is clicked.
  */
  function initPDPButton(swat) {
    const context = document.getElementById("wishlist-modal");
    const btn = document.querySelector(".custom-wishlist-button-product");
    if (!btn) return;
    const pageData = window.SwymPageData;
    if (!pageData || pageData.et !== 1) return;
    const product = {
      epi: pageData.epi,
      empi: pageData.empi,
      du: pageData.du,
      dt: pageData.dt,
      iu: pageData.iu,
      pr: pageData.pr,
      cprops: getCustomProperties()
    };
    currentWishlistProduct = product;
    checkWishlistState(swat, btn, product);
    btn.addEventListener("click", function () {
      const requestToken = ++wishlistRequestToken;
      showWishlistPageLoader();
      currentWishlistButton = btn;
      const productURL = btn.dataset.du;
      fetchProductJSON(productURL)
        .then(function (productData) {
          if (requestToken !== wishlistRequestToken) {
            return;
          }
          if (customerLists.length) {
            return openWishlist(context, productData, btn, requestToken);
          }
          return new Promise(function (resolve) {
            loadCustomerLists(function () {
              if (requestToken !== wishlistRequestToken) {
                resolve();
                return;
              }
              resolve(openWishlist(context, productData, btn, requestToken));
            });
          });
        })
        .catch(function (error) {
          console.error("[Wishlist] Failed to fetch product data:", error);
        })
        .finally(function () {
          if (requestToken === wishlistRequestToken) {
            hideWishlistPageLoader();
          }
        });
    });
  }
  /**
  * Initializes wishlist buttons displayed on product cards.
  * Builds the product data from button data attributes and
  * synchronizes each button with its current wishlist state.
  */
  function initProductCardButtons(swat) {
    const buttons = document.querySelectorAll(".custom-wishlist-button-card");
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      const product = {
        epi: btn.dataset.epi,
        empi: btn.dataset.empi,
        du: btn.dataset.du,
        dt: btn.dataset.dt,
        iu: btn.dataset.iu,
        pr: btn.dataset.pr,
        cprops: getCustomProperties()
      };
      checkWishlistState(swat, btn, product);
    });
  }
  /**
  * Observes dynamically added product cards components.
  * Re-initializes wishlist buttons when new elements are added to the DOM.
  */
  function observeCollectionWishlistButtons() {
    const observer = new MutationObserver(function (mutations) {
      let shouldRefresh = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches(".custom-wishlist-button-card") || node.querySelector(".custom-wishlist-button-card")) {
            shouldRefresh = true;
          }
        });
      });
      if (shouldRefresh) {
        initProductCardButtons(swymInstance);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  /**
  * Checks whether the given product is currently present in the wishlist
  * and updates the corresponding wishlist button.
  */
  function checkWishlistState(swat, btn, product) {
    if (!product) return;
    syncWishlistButton(btn, isProductInWishlist(product));
  }
  /*
  * Returns custom metadata attached to wishlist products.
  * Includes storefront context, timestamp, and source information.
  */
  function getCustomProperties() {
    const path = window.location.pathname;
    let source = "";
    if (path === "/") {
      source = "home";
    } else if (path.includes("/collections/")) {
      source = "collection";
    } else if (path.includes("/search")) {
      source = "search";
    } else if (path.includes("/products/")) {
      source = "product";
    } else if (path.includes("/pages/brand/")) {
      source = "brand";
    } else if (path.includes("/pages/swym-wishlist") || path.includes("/pages/wishlist")) {
      source = "wishlist";
    }
    return {
      storefront_context:
        document.documentElement.dataset.storefrontContext || "",
      date: new Date().toISOString(),
      source: source
    };
  }
  /**
 * Opens and initializes the wishlist modal for the selected product.
 * Resets the previous state, populates product information,
 * and prepares the selected wishlist lists.
 */
  function openWishlist(context, productData, sourceBtn, requestToken) {
    if (!context || !productData) {
      return Promise.resolve();
    }
    const elements = getWishlistElements(context);
    resetWishlistState(context);
    elements.createPanel?.classList.remove("is-active");
    context._wishlistProductData = productData;
    context._wishlistVariantSelections = {};
    context._wishlistRequestToken = requestToken;
    if (elements.media) {
      elements.media.innerHTML = "";
    }
    var initialVariant = productData?.variants?.[0];
    var wishlistMediaPromise = initialVariant
      ? renderWishlistMedia(context, productData, initialVariant.id, requestToken)
      : Promise.resolve();
    if (elements.image) {
      elements.image.src = productData?.variants[0]?.featured_image?.src || productData.featured_image || productData.images?.[0] || "";
      elements.image.alt = productData?.variants[0]?.featured_image?.alt || productData.title || currentWishlistProduct?.dt || "";
    }
    updateWishlistVendor(context, productData.vendor);
    if (elements.title) {
      elements.title.textContent = productData.title || currentWishlistProduct?.dt || "";
    }
    if (elements.price) {
      elements.price.textContent = formatPrice(productData.price);
    }
    const hasCompleteVariant = buildWishlistVariantSelectors(context, productData, sourceBtn);
    if (hasCompleteVariant) {
      const selectedVariant = findSelectedWishlistVariant(productData, context._wishlistVariantSelections);
      if (selectedVariant) {
        updateWishlistSelectedVariant(context, productData, selectedVariant);
        updateWishlistSelectedLabels(context);
      }
    } else {
      hideWishlistListsUntilVariantSelected(context);
    }
    updateWishlistVariantSelectionMessage(context, productData);
    return wishlistMediaPromise.then(function () {
      if (requestToken !== undefined && context._wishlistRequestToken !== requestToken) {
        return;
      }
      context.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  }
  /**
  * Renders the customer's wishlist lists as checkbox options
  * inside the wishlist modal.
  */
  function renderLists(context, lists) {
    const elements = getWishlistElements(context);
    const wrapper = elements.listWrapper;
    if (!wrapper) {
      return;
    }
    wrapper.innerHTML = "";
    if (!lists || !lists.length) {
      return;
    }
    lists.forEach(function (list) {
      const checked = selectedLists.has(String(list.lid));
      const itemCount = list.cnt != null ? Number(list.cnt) : (list.listcontents || []).length;
      const itemLabel = itemCount === 1 ? "item" : "items";
      const row = document.createElement("label");
      row.className = "wishlist-list-row" + (checked ? " wishlist-list-row--selected" : "");
      row.innerHTML = `
      <span class="wishlist-list-row__left">
        <input type="checkbox" value="${esc(list.lid)}" ${checked ? "checked" : ""}>
        <span class="wishlist-list-row__title">${esc(list.lname)}</span>
      </span>
      <span class="wishlist-list-row__count">${itemCount} ${itemLabel}</span>`;
      wrapper.appendChild(row);
    });
  }
  /**
 * Processes all wishlist changes.
 * Creates new lists, adds the product to selected lists,
 * removes the product from unselected lists, and refreshes the UI.
 */
  function updateLists(context) {
    const elements = getWishlistElements(context);
    const createRequests = [];
    if (elements.createPanel?.classList.contains("is-active")) {
      const options = elements.createPanel.querySelectorAll(".wishlist-create-option");
      options.forEach(function (option) {
        const input = option.querySelector(".wishlist-list-name");
        const checkbox = option.querySelector(".wishlist-modal__pending-checkbox");
        if (!input || !checkbox) return;
        const isValid = validateCreateListOption(context, option);
        if (!isValid) return;
        createRequests.push({
          name: input.value.trim(),
          checked: checkbox.checked
        });
      });
    }
    const btn = elements.updateBtn;
    if (!btn) { return; }
    const isCreateMode = context.classList.contains("is-create-mode");
    const addLists = isCreateMode ? [] : listsToAdd.slice();
    const removeLists = isCreateMode ? [] : listsToRemove.slice();
    btn.disabled = true;
    btn.classList.add("is-loading");
    const product = getListItem(currentWishlistProduct);
    const operations = [];
    //Create new list.
    createRequests.forEach(function (createRequest) {
      operations.push(
        new Promise(function (resolve) {
          swymInstance.createList(
            {
              lname: createRequest.name,
              lprops: {
                public: false
              }
            },
            function (response) {
              trackAmplitudeEvent('wishlist_list_created', {
                list_id: response.lid,
                list_name: createRequest.name
              });
              if (!createRequest.checked) {
                resolve();
                return;
              }
              swymInstance.addToList(response.lid, product,
                function () {
                  resolve();
                  const eventName = 'wishlist_item_saved';
                  const properties = {
                    product_id: product.empi,
                    variant_id: product.epi,
                    list_id: response.lid,
                    source: product.cprops.source,
                    storefront: product.cprops.storefront_context
                  };
                  trackAmplitudeEvent(eventName, properties);
                  trackKlaviyoEvent(eventName, properties);
                },
                function (error) {
                  console.error("[Wishlist] Failed adding product to new list:", error);
                  resolve();
                }
              );
            },
            function (error) {
              console.error("[Wishlist] Create list failed:", error);
              resolve();
            }
          );
        })
      );
    });
    //Add product to existing lists.
    if (addLists.length) {
      operations.push(new Promise(function (resolve) {
        swymInstance.addProductToLists(product, addLists,
          function (response) {
            resolve();
            const eventName = 'wishlist_item_saved';
            const properties = {
              product_id: product.empi,
              variant_id: product.epi,
              list_id: addLists[0],
              source: product.cprops.source,
              storefront: product.cprops.storefront_context
            };
            trackAmplitudeEvent(eventName, properties);
            trackKlaviyoEvent(eventName, properties);
          },
          function (error) {
            console.error("[Wishlist] Add to lists failed:", error);
            resolve();
          }
        );
      })
      );
    }
    // Remove product from lists.
    if (removeLists.length) {
      operations.push(new Promise(function (resolve) {
        swymInstance.removeProductFromLists(product, removeLists,
          function (response) {
            resolve();
            const eventName = 'wishlist_item_removed';
            const properties = {
              product_id: product.empi,
              variant_id: product.epi,
              list_id: removeLists[0]
            };
            trackAmplitudeEvent(eventName, properties);
            trackKlaviyoEvent(eventName, properties);
          },
          function (error) {
            console.error("[Wishlist] Remove from lists failed:", error);
            resolve();
          }
        );
      })
      );
    }
    if (!operations.length) {
      btn.disabled = true;
      btn.classList.remove("is-loading");
      return;
    }
    Promise.all(operations)
      .then(function () {
        loadCustomerLists(function () {
          const isNowInWishlist = isProductInWishlist(currentWishlistProduct);
          let toastType;
          if (!originalSelections.size && isNowInWishlist) {
            toastType = "added";
          } else if (originalSelections.size && !isNowInWishlist) {
            toastType = "removed";
          } else {
            toastType = "updated";
          }
          if (currentWishlistButton) {
            syncAllWishlistUI(currentWishlistProduct);
          }
          closeWishlist(context);
          showWishlistToast(currentWishlistProduct, toastType);
          if (document.getElementById("swym-wishlist-lists-grid")) {
            fetchAndRenderWishlistPageLists(swymInstance);
          }
          var drawer = document.getElementById("swym-wishlist-drawer");
          if (drawer && !drawer.hidden && currentDrawerLid) {
            appendNewWishlistDrawerItems(currentDrawerSwat || swymInstance, currentDrawerLid);
          }
        });
      })
  }
  /**
 * Handles clicks on product-card wishlist buttons.
 * Sets the current product and opens the wishlist modal.
 */
  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".custom-wishlist-button-card");
    if (btn) {
      const context = document.getElementById("wishlist-modal");
      const product = {
        epi: btn.dataset.epi,
        empi: btn.dataset.empi,
        du: btn.dataset.du,
        dt: btn.dataset.dt,
        iu: btn.dataset.iu,
        pr: btn.dataset.pr,
        cprops: getCustomProperties()
      };
      const requestToken = ++wishlistRequestToken;
      showWishlistPageLoader();
      currentWishlistProduct = product;
      currentWishlistButton = btn;
      const productURL = btn.dataset.du;
      fetchProductJSON(productURL)
        .then(function (productData) {
          if (requestToken !== wishlistRequestToken) {
            return;
          }
          if (customerLists.length) {
            return openWishlist(context, productData, btn, requestToken);
          }
          return new Promise(function (resolve) {
            loadCustomerLists(function () {
              if (requestToken !== wishlistRequestToken) {
                resolve();
                return;
              }
              resolve(openWishlist(context, productData, btn, requestToken));
            });
          });
        })
        .catch(function (error) {
          console.error("[Wishlist] Failed to fetch product data:", error);
        })
        .finally(function () {
          if (requestToken === wishlistRequestToken) {
            hideWishlistPageLoader();
          }
        });
      return;
    }
    const swatch = event.target.closest("nosto-dynamic-card .js-product-card-swatch");
    if (swatch) {
      const cardNode = swatch.closest("nosto-dynamic-card");
      const wishlistBtn = cardNode?.querySelector(".custom-wishlist-button-card");
      if (!wishlistBtn) {
        return;
      }
      setTimeout(() => {
        const activeSwatch = cardNode.querySelector(".js-product-card-swatch.is-active");
        const variantId = activeSwatch?.getAttribute("data-variant-id");
        const variantImg = cardNode.querySelector(".product-card__image-wrapper.is-active .product-card__image");
        const variantImgSrc = variantImg?.currentSrc || variantImg?.src;
        if (!variantId) {
          return;
        }
        wishlistBtn.dataset.epi = variantId;
        if (variantImgSrc) {
          wishlistBtn.dataset.iu = variantImgSrc;
        }
        const product = {
          epi: wishlistBtn.dataset.epi,
          empi: wishlistBtn.dataset.empi,
          du: wishlistBtn.dataset.du,
          dt: wishlistBtn.dataset.dt,
          iu: wishlistBtn.dataset.iu,
          pr: wishlistBtn.dataset.pr,
          cprops: getCustomProperties()
        };
        checkWishlistState(swymInstance, wishlistBtn, product);
      }, 500);
    }
  }, true);
  /**
 * Displays the wishlist toast notification after a wishlist action.
 * Supports added, updated, and removed states.
 */
  let wishlistToastTimer, toastDuration = 3000;
  function showWishlistToast(product, type, customMessage) {
    const toast = document.getElementById("wishlist-toast");
    if (!toast) {
      return;
    }
    const image = toast.querySelector(".wishlist-toast__image");
    const title = toast.querySelector(".wishlist-toast__title");
    const message = toast.querySelector(".wishlist-toast__message");
    const toastButton = toast.querySelector(".wishlist-toast__button");
    const progress = toast.querySelector(".wishlist-toast__progress");
    image.hidden = false;
    title.hidden = false;
    toastButton.hidden = true;
    image.src = "";
    image.alt = "";
    title.textContent = "";
    message.textContent = "";
    if (type === "list-created" || type === "oos-removed" || type === "list-edited" || type === "message" || type === 'list-renamed') {
      image.hidden = true;
      title.hidden = true;
      toastButton.hidden = true;
      if (type === "oos-removed") {
        message.textContent = "All Out of stock items are removed from the list";
      } else if (type === "list-edited") {
        message.textContent = "List status has been updated successfully.";
      } else if (type === "list-renamed") {
        message.textContent = "List name has been updated successfully.";
      } else if (type === "list-created") {
        message.textContent = "New list has been created successfully.";
      } else {
        message.textContent = customMessage || "";
      }
    } else {
      image.hidden = false;
      title.hidden = false;
      image.src = product?.iu || "";
      image.alt = product?.dt || "";
      title.textContent = product?.dt || "";
      if (type === "removed") {
        message.textContent = message.dataset.itemRemoved;
        toastButton.hidden = true;
      } else if (type === "updated") {
        message.textContent = message.dataset.itemUpdated;
        toastButton.hidden = false;
      } else {
        message.textContent = message.dataset.itemSaved;
        toastButton.hidden = false;
      }
    }
    clearTimeout(wishlistToastTimer);
    progress.style.animation = "none";
    progress.offsetWidth;
    progress.style.animation = `wishlistToastProgress ${toastDuration}ms linear forwards`;
    toast.classList.add("is-visible");
    wishlistToastTimer = setTimeout(function () {
      toast.classList.remove(
        "is-visible"
      );
    }, toastDuration);
  }
  /**
 * Prepares the initial wishlist selections for the current product.
 * Identifies which lists already contain the product and resets
 * the pending add/remove changes.
 */
  function prepareSelections(context, product) {
    const elements = getWishlistElements(context);
    product = product || currentWishlistProduct;
    if (!product?.epi || !product?.empi) {
      return;
    }
    originalSelections.clear();
    selectedLists.clear();
    pendingNewList = null;
    pendingRemoveList = null;
    updateRemovalNote(context);
    listsToAdd = [];
    listsToRemove = [];
    customerLists.forEach(function (list) {
      const exists = (list.listcontents || []).some(function (item) {
        return (String(item.empi) === String(product.empi) && String(item.epi) === String(product.epi));
      });
      if (exists) {
        originalSelections.add(String(list.lid));
        selectedLists.add(String(list.lid));
      }
    });
    renderLists(context, customerLists);
    updateActionButton(elements.updateBtn);
  }
  function updateWishlistVendor(context, vendor) {
    const elements = getWishlistElements(context);
    if (!elements.vendor) {
      return;
    }
    elements.vendor.textContent = vendor || "";
    elements.vendor.hidden = !vendor;
  }
  function findWishlistImageVariant(productData, selections) {
    const variants = productData?.variants || [];
    const selectionEntries = Object.entries(selections || {});
    if (!selectionEntries.length) {
      return null;
    }
    return variants.find(function (variant) {
      if (variant.available === false) {
        return false;
      }
      return selectionEntries.every(function ([position, value]) {
        const optionValue = variant["option" + position];
        return String(optionValue) === String(value);
      });
    }) || null;
  }
  function buildWishlistVariantSelectors(context, productData, sourceBtn) {
    const elements = getWishlistElements(context);
    if (!elements.variantWrapper) {
      return;
    }
    elements.variantWrapper.innerHTML = "";
    const options = (productData.options || []).slice().sort(function (a, b) {
      return Number(a.position || 0) - Number(b.position || 0);
    });
    context._wishlistVariantSelections = {};
    options.forEach(function (option) {
      const optionName = option.name;
      const values = option.values || [];
      const isSwatch = isSwatchOption(optionName);
      if ((isSwatch || option.name == 'Title') && values.length === 1) {
        context._wishlistVariantSelections[String(option.position)] = values[0];
        return;
      }
      const optionWrapper = document.createElement("div");
      optionWrapper.className = isSwatch ? "product-options__swatch wishlist-modal__variant-option" : "product-options__default wishlist-modal__variant-option";
      optionWrapper.dataset.optionPosition = option.position;
      const label = document.createElement("div");
      label.className = "product-options__option-label";
      label.appendChild(document.createTextNode(optionName));
      label.appendChild(document.createTextNode(":"));
      const selectedValueEl = document.createElement("span");
      if (isSwatch) {
        selectedValueEl.className = "product-options__swatch-value js-swatch-label-name wishlist-modal__selected-value error";
        selectedValueEl.dataset.swatchName = optionName;
        selectedValueEl.dataset.swatchPosition = option.position;
      } else {
        selectedValueEl.className = "wishlist-modal__selected-value error";
      }
      selectedValueEl.textContent = getVariantOptionPlaceholder(optionName);
      label.appendChild(selectedValueEl);
      optionWrapper.appendChild(label);
      let valuesWrapper;
      if (isSwatch) {
        valuesWrapper = document.createElement("div");
        valuesWrapper.className = "product-options__swatch-container";
      }
      values.forEach(function (value) {
        const variantOption = createWishlistVariantOption(context, productData, option, value, isSwatch, sourceBtn);
        if (isSwatch) {
          valuesWrapper.appendChild(variantOption);
        } else {
          optionWrapper.appendChild(variantOption);
        }
      });
      if (isSwatch) {
        optionWrapper.appendChild(valuesWrapper);
      }
      elements.variantWrapper.appendChild(optionWrapper);
    });
    updateWishlistSelectedLabels(context);
    updateWishlistVariantAvailability(context, productData);
    updateWishlistVariantSelectionMessage(context, productData);
    const selections = context._wishlistVariantSelections || {};
    const imageVariant = findWishlistImageVariant(productData, selections);
    if (imageVariant) {
      const image = imageVariant?.featured_image?.src || imageVariant?.featured_media?.preview_image?.src || productData?.featured_image;
      if (elements.image && image) {
        elements.image.src = image;
      }
    }
    const selectedVariant = findSelectedWishlistVariant(productData, selections);
    if (selectedVariant) {
      updateWishlistSelectedVariant(context, productData, selectedVariant);
      const modalElements = getWishlistElements(context);
      if (modalElements.createBtn) {
        modalElements.createBtn.disabled = false;
      }
      updateActionButton(modalElements.updateBtn);
    } else {
      const modalElements = getWishlistElements(context);
      if (modalElements.updateBtn) {
        modalElements.updateBtn.disabled = true;
      }
      if (modalElements.createBtn) {
        modalElements.createBtn.disabled = true;
      }
    }
    return Boolean(selectedVariant);
  }
  function getVariantOptionPlaceholder(optionName) {
    return "Confirm " + String(optionName).trim();
  }
  function isSwatchOption(optionName) {
    return String(optionName || "").toLowerCase() === "color";
  }
  function createWishlistVariantOption(context, productData, option, value, isSwatch, sourceBtn) {
    const wrapper = document.createElement("div");
    wrapper.className = isSwatch ? "radio-container radio-option-swatch-circle" : "radio-option";
    const input = document.createElement("input");
    input.type = "radio";
    input.className = "visually-hidden radio-input wishlist-modal__variant-input";
    input.value = value;
    input.name = "wishlist-option-" + option.position;
    input.dataset.option = option.name;
    input.dataset.optionName = option.name;
    input.dataset.optionPosition = option.position;
    input.dataset.optionValue = value;
    input.setAttribute("aria-checked", "false");
    input.id = "wishlist-modal-option-" + String(option.position) + "-" + String(value).toLowerCase().replace(/[^a-z0-9]+/g, "-");
    const label = document.createElement("label");
    label.htmlFor = input.id;
    if (isSwatch) {
      label.className = "radio-option-swatch-circle__label";
      applyWishlistSwatchStyle(label, value, sourceBtn);
      const hiddenText = document.createElement("span");
      hiddenText.className = "visually-hidden";
      hiddenText.textContent = value;
      label.appendChild(hiddenText);
    } else {
      label.className = "radio-option__label";
      label.textContent = value;
    }
    wrapper.appendChild(input);
    wrapper.appendChild(label);
    if (isSwatch) {
      const tooltip = document.createElement("span");
      tooltip.className = "radio-option-tooltip";
      tooltip.setAttribute("aria-hidden", "true");
      tooltip.textContent = value;
      wrapper.appendChild(tooltip);
    }
    input.addEventListener("change", function () {
      handleWishlistVariantSelection(context, productData, option, value);
    });
    return wrapper;
  }
  function applyWishlistSwatchStyle(label, value, sourceBtn) {
    if (!label || !value || !sourceBtn) {
      return;
    }
    var normalizedValue = String(value).trim();
    var swatchHandle = normalizedValue.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    var swatchDataId = swatchHandle + '-swatch-data';
    var sourceContainer = sourceBtn.closest('.product-card, .product');
    if (!sourceContainer) {
      return;
    }
    var swatchData = sourceContainer.querySelector('#' + CSS.escape(swatchDataId));
    if (!swatchData) {
      return;
    }
    var content = swatchData.textContent || '';
    var styleMatch = content.match(/style\s*=\s*"([^"]*)"/);
    if (!styleMatch) {
      return;
    }
    label.setAttribute('style', styleMatch[1].trim());
  }
  function handleWishlistVariantSelection(context, productData, option, value) {
    const selections = context._wishlistVariantSelections || {};
    selections[String(option.position)] = value;
    context._wishlistVariantSelections = selections;
    updateWishlistSelectedLabels(context);
    updateWishlistVariantAvailability(context, productData);
    updateWishlistVariantSelectionMessage(context, productData);
    const imageVariant = findWishlistImageVariant(productData, selections);
    if (imageVariant) {
      const elements = getWishlistElements(context);
      const image = imageVariant?.featured_image?.src || imageVariant?.featured_media?.preview_image.src || productData?.featured_image;
      if (elements.image && image) {
        elements.image.src = image;
      }
    }
    const selectedVariant = findSelectedWishlistVariant(productData, selections);
    if (!selectedVariant) {
      hideWishlistListsUntilVariantSelected(context);
      const elements = getWishlistElements(context);
      if (elements.updateBtn) {
        elements.updateBtn.disabled = true;
      }
      if (elements.createBtn) {
        elements.createBtn.disabled = true;
      }
      return;
    }
    updateWishlistSelectedVariant(context, productData, selectedVariant);
    const elements = getWishlistElements(context);
    if (elements.createBtn) {
      elements.createBtn.disabled = false;
    }
    // Existing function handles Add To List state.
    updateActionButton(elements.updateBtn);
  }
  function findSelectedWishlistVariant(productData, selections) {
    const options = (productData.options || []).slice().sort(function (a, b) {
      return Number(a.position || 0) - Number(b.position || 0);
    });
    const allSelected = options.every(function (option) {
      return selections[String(option.position)];
    });
    if (!allSelected) {
      return null;
    }
    return (productData.variants || []).find(function (variant) {
      return options.every(function (option, index) {
        const selectedValue = selections[String(option.position)];
        return String(variant["option" + (index + 1)]) === String(selectedValue);
      });
    }) || null;
  }
  function updateWishlistSelectedLabels(context) {
    const selections = context._wishlistVariantSelections || {};
    context.querySelectorAll(".wishlist-modal__variant-option").forEach(function (optionWrapper) {
      const position = optionWrapper.dataset.optionPosition;
      const selectedValue = selections[String(position)];
      const selectedLabel = optionWrapper.querySelector(".wishlist-modal__selected-value");
      if (!selectedLabel) {
        return;
      }
      if (selectedValue) {
        selectedLabel.textContent = 'Selected';
        selectedLabel.classList.remove('error');
      }
    });
    context.querySelectorAll(".wishlist-modal__variant-input").forEach(function (input) {
      const position = input.dataset.optionPosition;
      const value = input.dataset.optionValue;
      const isSelected = String(selections[String(position)]) === String(value);
      input.checked = isSelected;
      input.setAttribute("aria-checked", isSelected ? "true" : "false");
      const label = context.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.classList.toggle("is-selected", isSelected);
      }
    });
  }
  function updateWishlistVariantAvailability(context, productData) {
    const selections = context._wishlistVariantSelections || {};
    context.querySelectorAll(".wishlist-modal__variant-input").forEach(function (input) {
      const position = String(input.dataset.optionPosition);
      const value = input.dataset.optionValue;
      const testSelections = Object.assign({}, selections);
      testSelections[position] = value;
      const possibleVariant = (productData.variants || []).some(function (variant) {
        return isWishlistVariantCompatible(productData, variant, testSelections);
      });
      input.disabled = !possibleVariant;
      input.setAttribute("aria-disabled", possibleVariant ? "false" : "true");
      const label = context.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.classList.toggle("is-disabled", !possibleVariant);
      }
      const container = input.closest(".radio-option, .radio-container");
      if (container) {
        container.classList.toggle("is-disabled", !possibleVariant);
      }
    });
  }
  function isWishlistVariantCompatible(productData, variant, selections) {
    const options = (productData.options || []).slice().sort(function (a, b) {
      return Number(a.position || 0) - Number(b.position || 0);
    });
    return options.every(function (option, index) {
      const selectedValue = selections[String(option.position)];
      if (!selectedValue) {
        return true;
      }
      return String(variant["option" + (index + 1)]) === String(selectedValue);
    });
  }
  function updateWishlistSelectedVariant(context, productData, variant) {
    currentWishlistProduct = Object.assign({}, currentWishlistProduct,
      {
        epi: variant.id,
        empi: productData.id,
        dt: productData.title,
        du: window.location.origin + productData.url,
        iu: variant?.featured_image?.src ||
          variant?.featured_media?.preview_image?.src ||
          productData?.featured_image ||
          currentWishlistProduct.iu,
        pr: variant.price
      }
    );
    const elements = getWishlistElements(context);
    if (elements.image) {
      const image = variant?.featured_image?.src || variant.featured_media?.preview_image.src || productData.featured_image;
      if (image) {
        elements.image.src = image;
      }
    }
    if (!updateWishlistMediaImage(context, variant)) {
      renderWishlistMedia(context, productData, variant.id);
    }
    updateWishlistVariantPrice(context, variant);
    if (elements.variantError) {
      elements.variantError.textContent = "";
      elements.variantError.hidden = true;
    }
    showWishlistListsForSelectedVariant(context, currentWishlistProduct);
  }
  function updateWishlistVariantPrice(context, variant) {
    const elements = getWishlistElements(context);
    if (!elements.price) {
      return;
    }
    const price = Number(variant.price || 0);
    const compareAtPrice = Number(variant.compare_at_price || 0);
    if (compareAtPrice && compareAtPrice > price) {
      elements.price.innerHTML = '<span class="price--compare">' +
        formatPrice(compareAtPrice) + '</span>' +
        '<span class="price--sale">' +
        formatPrice(price) + '</span>';
      return;
    }
    elements.price.textContent = formatPrice(price);
  }
  function hideWishlistListsUntilVariantSelected(context) {
    const elements = getWishlistElements(context);
    if (elements.listsContainer) {
      elements.listsContainer.hidden = true;
    }
    if (elements.listWrapper) {
      elements.listWrapper.hidden = true;
    }
    if (elements.updateBtn) {
      elements.updateBtn.disabled = true;
    }
  }
  function showWishlistListsForSelectedVariant(context, product) {
    const elements = getWishlistElements(context);
    if (context.classList.contains("is-create-mode")) {
      updateActionButton(elements.updateBtn);
      return;
    }
    if (elements.listWrapper) {
      elements.listWrapper.hidden = false;
    }
    if (elements.listsContainer) {
      elements.listsContainer.hidden = false;
    }
    prepareSelections(context, product);
    updateWishlistListsVisibility(context);
  }
  function updateWishlistListsVisibility(context) {
    const elements = getWishlistElements(context);
    if (!elements.listsContainer) {
      return;
    }
    const hasLists = customerLists && customerLists.length > 0;
    let emptyMessage = elements.listsContainer.querySelector(".wishlist-modal__empty-message");
    if (!hasLists) {
      elements.listsContainer.classList.add("wishlist-modal__lists-container--empty");
      if (!emptyMessage) {
        emptyMessage = document.createElement("p");
        emptyMessage.className = "wishlist-modal__empty-message";
        elements.listsContainer.appendChild(emptyMessage);
      }
      emptyMessage.hidden = false;
      emptyMessage.textContent = "You don't have any lists yet; please create one to save this item";
      if (elements.listWrapper) {
        elements.listWrapper.hidden = true;
      }
      if (elements.createBtn) {
        elements.createBtn.classList.add("wishlist-modal__create-btn--last");
      }
      return;
    }
    elements.listsContainer.classList.remove("wishlist-modal__lists-container--empty");
    if (emptyMessage) {
      emptyMessage.remove();
    }
    if (elements.createBtn) {
      elements.createBtn.classList.remove("wishlist-modal__create-btn--last");
    }
  }
  function updateWishlistVariantSelectionMessage(context, productData) {
    const elements = getWishlistElements(context);
    if (!elements.variantError) {
      return;
    }
    const options = (productData.options || []).slice().sort(function (a, b) {
      return Number(a.position || 0) - Number(b.position || 0);
    });
    const selections = context._wishlistVariantSelections || {};
    const unselectedOption = options.find(function (option) {
      return !selections[String(option.position)];
    });
    if (!unselectedOption) {
      elements.variantError.textContent = "";
      elements.variantError.hidden = true;
      elements.createBtn.disabled = false;
      if (customerLists.length != 0) {
        const btn = elements.createBtn;
        btn.textContent = btn.dataset.labelUpdate;
        btn.classList.add('has-list');
      }
      return;
    }
    const prefix = elements.variantError.dataset.prefix || "";
    const suffix = elements.variantError.dataset.suffix || "";
    elements.variantError.textContent = prefix + " " + unselectedOption.name.toLowerCase() + " " + suffix;
    elements.variantError.hidden = false;
  }
  /**
 * Updates the Add To List / Update List button state.
 * Enables the button when there are list changes or a valid
 * new list creation request.
 */
  function updateActionButton(btn) {
    if (!btn) {
      return;
    }
    const context = btn.closest("#wishlist-modal");
    if (!context) {
      return;
    }
    const selectedVariant = findSelectedWishlistVariant(context._wishlistProductData, context._wishlistVariantSelections || {});
    if (!selectedVariant) {
      btn.disabled = true;
      btn.textContent = btn.dataset.labelDefault;
      return;
    }
    const hasAdd = listsToAdd.length > 0;
    const hasRemove = listsToRemove.length > 0;
    let hasCreate = false;
    const options = context.querySelectorAll(".wishlist-create-option");
    options.forEach(function (option) {
      const input = option.querySelector(".wishlist-list-name");
      const checkbox = option.querySelector(".wishlist-modal__pending-checkbox");
      if (!input || !checkbox) {
        return;
      }
      const name = input.value.trim();
      if (checkbox.checked && name.length >= 3 && validateCreateListOption(context, option)) {
        hasCreate = true;
      }
    });
    btn.disabled = !(hasAdd || hasRemove || hasCreate);
    btn.textContent = hasRemove ? btn.dataset.labelUpdate : btn.dataset.labelDefault;
  }
  /**
 * Updates the Add To List / Update List button state.
 * Enables the button when there are list changes or a valid
 * new list creation request.
 */
  function calculateListChanges() {
    listsToAdd = [];
    listsToRemove = [];
    if (pendingNewList) {
      listsToAdd.push(pendingNewList);
      return;
    }
    if (pendingRemoveList) {
      listsToRemove.push(pendingRemoveList);
    }
  }
  /**
 * Converts the current wishlist product into the product structure
 * required by the Swym wishlist APIs.
 */
  function updateRemovalNote(context) {
    const note = context.querySelector(".wishlist-modal__removal-note");
    if (!note) {
      return;
    }
    const show = Boolean(pendingRemoveList) && !context.classList.contains("is-create-mode");
    note.textContent = show ? (note.dataset.message || "") : "";
    note.hidden = !show;
  }
  function getListItem(product) {
    return {
      epi: product.epi,
      empi: product.empi,
      du: product.du,
      dt: product.dt,
      iu: product.iu,
      pr: product.pr,
      cprops: product.cprops
    };
  }

  function enterCreateListMode(context) {
    if (context.classList.contains("is-create-mode")) {
      return;
    }
    const elements = getWishlistElements(context);
    context.classList.add("is-create-mode");
    listsToAdd = [];
    listsToRemove = [];
    pendingNewList = null;
    pendingRemoveList = null;
    selectedLists.clear();
    updateRemovalNote(context);
    if (elements.listWrapper) {
      elements.listWrapper.hidden = true;
    }
    const emptyMessage = elements.listsContainer && elements.listsContainer.querySelector(".wishlist-modal__empty-message");
    if (emptyMessage) {
      emptyMessage.hidden = true;
    }
    if (elements.createBtn) {
      elements.createBtn.hidden = true;
    }
    elements.createPanel?.classList.add("is-active");
    appendCreateListOption(context);
    updateActionButton(elements.updateBtn);
  }
  /**
 * Closes the wishlist modal and clears all temporary wishlist state.
 */
  function closeWishlist(context) {
    context.classList.remove("is-open");
    document.body.style.overflow = "auto";
    const elements = getWishlistElements(context);
    elements.updateBtn && (elements.updateBtn.disabled = true, elements.updateBtn.textContent = elements.updateBtn.dataset.labelDefault);
    context.classList.remove("is-create-mode");
    elements.createPanel?.classList.remove("is-active");
    elements.createPanel?.replaceChildren();
    elements.createBtn && (elements.createBtn.disabled = false, elements.createBtn.hidden = false);
    listsToAdd = [];
    listsToRemove = [];
    selectedLists.clear();
    originalSelections.clear();
    pendingNewList = null;
    pendingRemoveList = null;
    updateRemovalNote(context);
  }
  /**
 * Binds all wishlist modal events.
 * Handles create list, update list, close, overlay, input,
 * and checkbox interactions.
 */
  function bindWishlistEvents(context) {
    const elements = getWishlistElements(context);
    elements.createBtn?.addEventListener("click", function () {
      enterCreateListMode(context);
    });
    elements.updateBtn?.addEventListener("click", function () { updateLists(context); });
    elements.closeBtn?.addEventListener("click", function () { closeWishlist(context); });
    elements.overlay?.addEventListener("click", function () { closeWishlist(context); });
    elements.pageCreateListBtn?.addEventListener("click", function () {
      openGlobalCreateList();
    });
    context.addEventListener("input", function (e) {
      if (!e.target.matches(".wishlist-global-create .wishlist-list-name")) {
        return;
      }
      const createWrapper = e.target.closest(".wishlist-global-create");
      const option = e.target.closest(".wishlist-create-option");
      const submitBtn = createWrapper?.querySelector(".wishlist-global-create-submit");
      if (!createWrapper || !option || !submitBtn) return;
      const isValid = validateCreateListOption(context, option);
      submitBtn.disabled = !isValid;
    });
    context.addEventListener("click", function (e) {
      if (e.target.closest(".wishlist-global-create__close")) {
        closeGlobalCreateList(context);
        return;
      }
      if (e.target.closest(".wishlist-global-create-submit")) {
        createGlobalList(context);
      }
    });
    context.addEventListener("input", function (e) {
      if (!e.target.matches(".wishlist-list-name")) {
        return;
      }
      const option = e.target.closest(".wishlist-create-option");
      if (!option) return;
      validateCreateListOption(context, option);
      updateActionButton(getWishlistElements(context).updateBtn);
    });
    context.addEventListener("change", function (e) {
      if (e.target.matches(".wishlist-modal__pending-checkbox")) {
        const option = e.target.closest(".wishlist-create-option");
        if (!option) return;
        updateActionButton(getWishlistElements(context).updateBtn);
        return;
      }
      if (!e.target.matches(".wishlist-list-row input[type='checkbox']")) return;
      const clickedLid = String(e.target.value);
      if (originalSelections.has(clickedLid)) {
        pendingNewList = null;
        pendingRemoveList = clickedLid;
        selectedLists = new Set();
      } else {
        pendingRemoveList = null;
        pendingNewList = clickedLid;
        selectedLists = new Set([clickedLid]);
      }
      const listRows = context.querySelectorAll(".wishlist-modal__lists .wishlist-list-row");
      listRows.forEach(function (row) {
        const checkbox = row.querySelector("input[type='checkbox']");
        if (!checkbox) return;
        const rowLid = String(checkbox.value);
        checkbox.checked = selectedLists.has(rowLid);
        row.classList.toggle(
          "wishlist-list-row--selected",
          checkbox.checked || rowLid === String(pendingRemoveList)
        );
      });
      updateRemovalNote(context);
      calculateListChanges();
      updateActionButton(getWishlistElements(context).updateBtn);
    });
  }
  /**
 * Validates a newly created wishlist list name.
 * Checks required value, minimum length, existing list names,
 * and duplicate names within the current modal.
 */
  function validateCreateListOption(context, option, excludeLid) {
    const input = option.querySelector(".wishlist-list-name");
    const error = option.querySelector(".wishlist-modal__error");
    if (!input || !error) {
      return false;
    }
    const name = input.value.trim();
    error.hidden = true;
    error.textContent = "";
    /*Required*/
    if (!name) {
      error.textContent = "Name is required";
      error.hidden = false;
      return false;
    }
    /* Minimum 3 characters*/
    if (name.length < 3) {
      error.textContent = "Minimum 3 characters required";
      error.hidden = false;
      return false;
    }
    /*
     * Duplicate list name.
     * During rename, ignore the list currently
     * being renamed.
     */
    const existsInExistingLists =
      customerLists.some(
        function (list) {
          if (excludeLid && String(list.lid) === String(excludeLid)) {
            return false;
          }
          return (
            String(list.lname).trim().toLowerCase() === name.toLowerCase()
          );
        });
    if (existsInExistingLists) {
      error.textContent = "List name already exists";
      error.hidden = false;
      return false;
    }
    /*
     * Duplicate create options.
     */
    const allOptions = context.querySelectorAll(".wishlist-create-option");
    let duplicateCount = 0;
    allOptions.forEach(function (currentOption) {
      const currentInput = currentOption.querySelector(".wishlist-list-name");
      if (currentInput && currentInput.value.trim().toLowerCase() === name.toLowerCase()) {
        duplicateCount++;
      }
    });
    if (duplicateCount > 1) {
      error.textContent = "List name already exists";
      error.hidden = false;
      return false;
    }
    return true;
  }
  /**
 * Resets the wishlist modal state before opening it for another product.
 * Clears list selections, pending changes, and create-list options.
 */
  function resetWishlistState(context) {
    const elements = getWishlistElements(context);
    listsToAdd = [];
    listsToRemove = [];
    originalSelections.clear();
    selectedLists.clear();
    pendingNewList = null;
    pendingRemoveList = null;
    context._wishlistVariantSelections = {};
    context._wishlistMediaSlider = null;
    updateRemovalNote(context);
    context.classList.remove("is-create-mode");
    if (elements.listWrapper) {
      elements.listWrapper.hidden = true;
    }
    if (elements.createBtn) {
      elements.createBtn.hidden = false;
    }
    elements.createPanel?.classList.remove("is-active");
    elements.createBtn && (elements.createBtn.disabled = true, elements.createBtn.textContent = elements.createBtn.dataset.labelDefault, elements.createBtn.classList.remove('has-list'));
    if (elements.createPanel) {
      elements.createPanel.innerHTML = "";
    }
    if (elements.listWrapper) {
      elements.listWrapper.innerHTML = "";
      elements.listWrapper.hidden = true;
    }
    if (elements.listsContainer) {
      elements.listsContainer.hidden = true;
    }
    if (elements.variantError) {
      elements.variantError.textContent = "";
      elements.variantError.hidden = true;
    }
    if (elements.updateBtn) {
      elements.updateBtn.disabled = true;
      elements.updateBtn.textContent = elements.updateBtn.dataset.labelDefault;
      elements.updateBtn.classList.remove("is-loading");
    }
    if (elements.image) {
      elements.image.src = '';
      elements.image.alt = '';
    }
    if (elements.price) {
      elements.price.textContent = "";
    }
  }
  /**
 * Returns all relevant wishlist modal elements for the given context.
 */
  function showWishlistPageLoader() {
    var loader = document.getElementById('wishlist-page-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'wishlist-page-loader';
      loader.setAttribute('aria-live', 'polite');
      loader.setAttribute('aria-busy', 'true');
      loader.style.cssText =
        'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(0,0,0,0.25);';
      loader.innerHTML =
        '<div style="width:40px;height:40px;border:3px solid rgba(255,255,255,0.4);' +
        'border-top-color:#fff;border-radius:50%;animation:wishlistLoaderSpin 0.8s linear infinite;"></div>' +
        '<style>@keyframes wishlistLoaderSpin{to{transform:rotate(360deg);}}</style>';
      document.body.appendChild(loader);
    }
    loader.style.display = 'flex';
  }

  function hideWishlistPageLoader() {
    var loader = document.getElementById('wishlist-page-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }
  function getWishlistElements(context) {
    return {
      listWrapper: context.querySelector(".wishlist-modal__lists"),
      listsContainer: context.querySelector(".wishlist-modal__lists-container"),
      createPanel: context.querySelector(".wishlist-modal__create"),
      input: context.querySelector("#wishlist-list-name"),
      checkbox: context.querySelector(".wishlist-modal__pending-checkbox"),
      error: context.querySelector(".wishlist-modal__error"),
      updateBtn: context.querySelector(".wishlist-modal__update"),
      createBtn: context.querySelector(".wishlist-modal__create-btn"),
      closeBtn: context.querySelector(".wishlist-modal__close"),
      overlay: context.querySelector(".wishlist-modal__overlay"),
      image: context.querySelector(".wishlist-modal__image"),
      media: context.querySelector(".js-quick-view-media"),
      title: context.querySelector(".wishlist-modal__product-title"),
      vendor: context.querySelector(".wishlist-modal__vendor"),
      price: context.querySelector(".wishlist-modal__price"),
      variantWrapper: context.querySelector(".wishlist-modal__variants"),
      variantError: context.querySelector(".select-to-continue"),
      pageCreateListBtn: document.querySelector(".create-list-global")
    };
  }
  /**
 * Checks whether a specific product exists in any customer wishlist list.
 */
  function isProductInWishlist(product) {
    if (!product?.empi || !product?.epi) {
      return false;
    }
    return customerLists.some(function (list) {
      return (list.listcontents || []).some(function (item) {
        return (
          String(item.empi) === String(product.empi) &&
          String(item.epi) === String(product.epi)
        );
      });
    });
  }
  /**
 * Synchronizes a wishlist button with the current product wishlist state.
 * Updates the active class, accessibility label, and button text.
 */
  function syncWishlistButton(btn, active) {
    if (!btn) return;
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-label", active ? "Remove from Wishlist" : "Add to Wishlist");
    const label = btn.querySelector(".btn-label");
    if (label) {
      label.textContent = active ? "Added to Wishlist" : "Add to Wishlist";
    }
  }
  /**
 * Synchronizes all wishlist buttons for the specified product.
 * Updates product card, and PDP wishlist buttons.
 */
  function syncAllWishlistUI(product) {
    if (!product?.empi || !product?.epi) {
      return;
    }
    const active = isProductInWishlist(product);
    // Product card buttons
    document.querySelectorAll(".custom-wishlist-button-card").forEach(function (btn) {
      if (String(btn.dataset.empi) === String(product.empi) && String(btn.dataset.epi) === String(product.epi)) {
        syncWishlistButton(btn, active);
      }
    });
    // Product/PDP media wishlist button
    document.querySelectorAll(".custom-wishlist-button-product").forEach(function (btn) {
      const buttonEmpi = btn.dataset.empi || window.SwymPageData?.empi;
      const buttonEpi = btn.dataset.epi || window.SwymPageData?.epi;
      if (String(buttonEmpi) === String(product.empi) && String(buttonEpi) === String(product.epi)) {
        syncWishlistButton(btn, active);
      }
    });
  }
  /**
 * Binds Swym's global variant change event.
 * Updates the PDP wishlist state when the product variant changes.
 */
  function bindGlobalVariantChange(swat) {
    if (!swat?.evtLayer || !swat?.JSEvents?.variantChanged) { return; }
    if (window.__wishlistVariantListenerBound) { return; }
    window.__wishlistVariantListenerBound = true;
    swat.evtLayer.addEventListener(
      swat.JSEvents.variantChanged,
      function (evt) {
        const variantId = evt?.detail?.d?.variant?.id;
        if (!variantId) {
          return;
        }
        const variant = window.SwymProductVariants?.[variantId];
        if (variant && window.SwymPageData) {
          const pdpProduct = {
            epi: variant.epi || variantId,
            empi: window.SwymPageData.empi,
            du: window.SwymPageData.du,
            dt: window.SwymPageData.dt,
            iu: variant.iu || window.SwymPageData.iu,
            pr: variant.pr || window.SwymPageData.pr,
            cprops: getCustomProperties()
          };
          currentWishlistProduct = pdpProduct;
          const pdpButton = document.querySelector(".custom-wishlist-button-product");
          syncWishlistButton(pdpButton, isProductInWishlist(pdpProduct));
          syncAllWishlistUI(pdpProduct);
        }
      }
    );
  }
  /**
 * Creates and appends a new create-list option to the wishlist modal.
 * Adds the list name input, product inclusion checkbox,
 * and validation error container.
 */
  function appendCreateListOption(context) {
    const elements = getWishlistElements(context);
    if (!elements.createPanel) return;
    if (elements.createPanel.querySelector(".wishlist-create-option")) return;
    const id = `create-list-${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;
    const option = document.createElement("div");
    option.className = "wishlist-create-option";
    option.dataset.createId = id;
    option.innerHTML = `
      <input class="wishlist-list-name" type="text" maxlength="50" placeholder="Enter list name">
      <label class="wishlist-list-row wishlist-list-row--pending">
        <input class="wishlist-modal__pending-checkbox" type="checkbox" checked >
        <span>Add this item to new list</span>
      </label>
      <p class="wishlist-modal__error" hidden ></p>
    `;
    elements.createPanel.appendChild(option);
    const input = option.querySelector("input[type='text']");
    input?.focus();
  }
  /**
 * Opens the global Create List modal.
 * This is completely separate from the existing #wishlist-modal
 * create-list flow.
 */
  function isValidEditListValue(modal, option) {
    var originalPublic =
      modal.dataset.originalPublic === 'true';
    var privacyInput = modal.querySelector('.wishlist-edit-privacy__input');
    var newPublic = privacyInput ? privacyInput.checked : originalPublic;
    var privacyChanged = newPublic !== originalPublic;
    return privacyChanged;
  }
  function openGlobalCreateList(mode, list) {
    mode = mode || 'create';
    var existingModal = document.querySelector('.wishlist-global-create-modal');
    if (existingModal) {
      existingModal.remove();
    }
    var isEdit = mode === 'edit';
    var isRename = mode === 'rename';
    var listName = isRename && list ? list.lname || '' : '';
    var isPublic = isEdit && list ? list.lprops?.public === true : false;
    var modal = document.createElement('div');
    modal.className = 'wishlist-modal wishlist-global-create-modal';
    modal.dataset.mode = mode;
    if ((isEdit || isRename) && list) {
      modal.dataset.lid = list.lid || '';
      modal.dataset.originalName = list.lname || '';
      modal.dataset.originalPublic = String(isPublic);
    }
    modal.innerHTML = `
    <div class="wishlist-modal__overlay"></div>
    <div class="wishlist-modal__dialog">
      <button type="button" class="wishlist-modal__close wishlist-global-create__close" aria-label="Close">×</button>
      <div class="wishlist-modal__header">
        <div class="wishlist-modal__content">
          <h5 class="wishlist-modal__product-title">${isEdit ? 'Edit List Status' : isRename ? 'Rename List' : 'Create a new list'}</h5>
        </div>
      </div>
      <div class="wishlist-modal__create is-active">
        ${isEdit ? `
            <div class="wishlist-edit-privacy">
              <label class="wishlist-edit-privacy__label">
                <span class="wishlist-edit-privacy__content">
                  <span class="wishlist-edit-privacy__title">List privacy</span>
                  <span class="wishlist-edit-privacy__status" data-privacy-status >${isPublic ? 'Public' : 'Private'}</span>
                </span>
                <span class="wishlist-edit-privacy__switch">
                  <input type="checkbox" class="wishlist-edit-privacy__input" ${isPublic ? 'checked' : ''} >
                  <span class="wishlist-edit-privacy__slider"></span>
                </span>
              </label>
            </div>
          `
        : `<div class="wishlist-create-option">
            <input class="wishlist-list-name" type="text" maxlength="50" placeholder="Enter list name" value="${esc(listName)}">
            <p class="wishlist-modal__error" hidden></p>
          </div>`
      }
      </div>
      <div class="wishlist-modal__footer">
        <button type="button" class="button wishlist-global-create-submit" disabled>
          ${isEdit || isRename ? 'Update List' : 'Create List'}
        </button>
      </div>
    </div>
  `;
    document.body.appendChild(modal);
    modal.classList.add('is-open');
    bindGlobalCreateListEvents(modal);
    var input = modal.querySelector('.wishlist-list-name');
    var option = modal.querySelector('.wishlist-create-option');
    var submitBtn = modal.querySelector('.wishlist-global-create-submit');
    var privacyInput = modal.querySelector('.wishlist-edit-privacy__input');
    if (isEdit) {
      submitBtn.disabled = !isValidEditListValue(modal,
        option
      );
      privacyInput?.addEventListener('change', function () {
        var status = modal.querySelector('[data-privacy-status]');
        if (status) {
          status.textContent = privacyInput.checked ? 'Public' : 'Private';
        }
        submitBtn.disabled = !isValidEditListValue(modal, option);
      });
    }
    input?.focus();
    if (isEdit && input) {
      input.setSelectionRange(input.value.length, input.value.length);
    }
  }
  /**
   * Binds events only for the new global Create List modal.
   * Existing #wishlist-modal events are not changed.
   */
  function bindGlobalCreateListEvents(modal) {
    const input = modal.querySelector(".wishlist-list-name");
    const submitBtn = modal.querySelector(".wishlist-global-create-submit");
    const closeBtn = modal.querySelector(".wishlist-global-create__close");
    const overlay = modal.querySelector(".wishlist-modal__overlay");
    input?.addEventListener("input", function () {
      const option = input.closest(".wishlist-create-option");
      if (!option) {
        return;
      }
      var isEdit = modal.dataset.mode === "edit";
      var isValid;
      if (isEdit) {
        isValid = isValidEditListValue(modal, option);
      } else {
        isValid = validateCreateListOption(modal, option);
      }
      submitBtn.disabled = !isValid;
    });
    submitBtn?.addEventListener("click", function () {
      createGlobalList(modal);
    });
    closeBtn?.addEventListener("click", function () {
      closeGlobalCreateList(modal);
    });
    overlay?.addEventListener("click", function () {
      closeGlobalCreateList(modal);
    });
  }
  /**
 * Creates a wishlist list from the global Create List modal.
 * Refreshes the customer lists, updates the wishlist page,
 * closes the modal, and shows the existing wishlist toast.
 */
  function createGlobalList(modal) {
    const mode = modal.dataset.mode || "create";
    const option = modal.querySelector(".wishlist-create-option");
    const input = option?.querySelector(".wishlist-list-name");
    const submitBtn = modal.querySelector(".wishlist-global-create-submit");
    if (!submitBtn) {
      return;
    }
    if (mode === 'create' && (!option || !input)) {
      return;
    }
    const isEdit = mode === "edit";
    var isValid;
    if (isEdit) {
      isValid = isValidEditListValue(modal, option);
    } else {
      isValid = validateCreateListOption(modal, option);
    }
    if (!isValid) {
      submitBtn.disabled = true;
      return;
    }
    /*Prevent double submission.*/
    submitBtn.disabled = true;
    submitBtn.classList.add("is-loading");
    /*------------------------------------------------
     * EDIT LIST
     * ------------------------------------------------*/
    if (mode === "edit") {
      const lid = modal.dataset.lid;
      const listName = modal.dataset.originalName || currentDrawerLname;
      const privacyInput = modal.querySelector(".wishlist-edit-privacy__input");
      const publicStatus = privacyInput ? privacyInput.checked : false;
      const updatePayload = {
        lid: lid,
        lname: listName,
        lprops: {
          public: publicStatus
        }
      };
      swymInstance.updateList(
        updatePayload,
        function (response) {
          customerLists = customerLists.map(
            function (list) {
              if (String(list.lid) === String(lid)) {
                return Object.assign({}, list,
                  {
                    lname: listName,
                    lprops: {
                      public: publicStatus
                    }
                  }
                );
              }
              return list;
            }
          );
          if (currentDrawerList && String(currentDrawerList.lid) === String(lid)) {
            currentDrawerList = Object.assign({}, currentDrawerList, {
              lname: listName,
              lprops: {
                public: publicStatus
              }
            });
          }
          updateWishlistDrawerHeading(currentDrawerList);
          fetchAndRenderWishlistPageLists(swymInstance);
          closeGlobalCreateList(modal);
          showWishlistToast(null, "list-edited");
        },
        function (error) {
          console.error("[Wishlist] Edit list failed:", error);
          submitBtn.disabled = false;
          submitBtn.classList.remove("is-loading");
        }
      );
      return;
    } else if (mode === 'rename') {
      const listName = input.value.trim();
      const lid = modal.dataset.lid;
      const updatePayload = {
        lid: lid,
        lname: listName
      };
      swymInstance.updateList(
        updatePayload,
        function (response) {
          customerLists = customerLists.map(
            function (list) {
              if (String(list.lid) === String(lid)) {
                return Object.assign({}, list,
                  {
                    lname: listName
                  }
                );
              }
              return list;
            }
          );
          if (currentDrawerList && String(currentDrawerList.lid) === String(lid)) {
            currentDrawerList = Object.assign({}, currentDrawerList, {
              lname: listName
            });
          }
          currentDrawerLname = listName;
          updateWishlistDrawerHeading(currentDrawerList);
          fetchAndRenderWishlistPageLists(swymInstance);
          closeGlobalCreateList(modal);
          showWishlistToast(null, "list-renamed");
        },
        function (error) {
          console.error("[Wishlist] Rename list failed:", error);
          submitBtn.disabled = false;
          submitBtn.classList.remove("is-loading");
        }
      );
      return;
    } else {
      /* ------------------------------------------------
     * CREATE LIST
     * ------------------------------------------------*/
      const listName = input.value.trim();
      swymInstance.createList(
        {
          lname: listName,
          lprops: {
            public: false
          }
        },
        function (response) {
          trackAmplitudeEvent('wishlist_list_created', {
            list_id: response.lid,
            list_name: listName
          });
          loadCustomerLists(function () {
            if (document.getElementById("swym-wishlist-lists-grid")) {
              fetchAndRenderWishlistPageLists(swymInstance);
            }
            closeGlobalCreateList(modal);
            showWishlistToast(null, "list-created");
          }
          );
        },
        function (error) {
          console.error("[Wishlist] Global create list failed:", error);
          submitBtn.disabled = false;
          submitBtn.classList.remove("is-loading");
        }
      );
    }
  }
  /*Closes and removes only the global Create List modal.
  * Does not affect #wishlist-modal. */
  function closeGlobalCreateList(modal) {
    if (!modal) {
      return;
    }
    modal.classList.remove("is-open");
    modal.remove();
  }
  var PRODUCT_CARD_SECTION_ID = 'wishlist-product-card';
  var WISHLIST_MEDIA_SECTION_ID = 'wishlist-media';
  var drawerHandlersBound = false;
  var SECTION_TRANSITION_MS = 250;
  var currentDrawerSwat = null;
  var currentDrawerLid = null;
  var currentDrawerLname = null;
  function initWishlistPage(swat) {
    var loginBlock = document.getElementById('swym-wishlist-login-required');
    var contentBlock = document.getElementById('swym-wishlist-content');
    var listsGrid = document.getElementById('swym-wishlist-lists-grid');
    // This page functionality is not present on PDP / collection / other pages.
    if (!loginBlock || !contentBlock || !listsGrid) {
      return;
    }
    bindShareListModalEvents();
    var isLoggedIn = swat.platform.isLoggedIn();
    if (!isLoggedIn) {
      loginBlock.style.display = '';
      contentBlock.style.display = 'none';
      return;
    }
    loginBlock.style.display = 'none';
    contentBlock.style.display = '';
    fetchAndRenderWishlistPageLists(swat);
  }
  function initSharedWishlistPage(swat) {
    var page = document.getElementById('swym-shared-wishlist-page');
    if (!page) {
      return;
    }
    var loading = document.getElementById('swym-shared-wishlist-loading');
    var content = document.getElementById('swym-shared-wishlist-content');
    var unavailable = document.getElementById('swym-shared-wishlist-unavailable');
    var title = document.getElementById('swym-shared-wishlist-title');
    var sharedBy = document.getElementById('swym-shared-wishlist-shared-by');
    var grid = document.getElementById('swym-shared-wishlist-grid');
    var empty = document.getElementById('swym-shared-wishlist-empty');
    if (!loading || !content || !unavailable || !grid) {
      return;
    }
    var params = new URLSearchParams(window.location.search);
    var lid = params.get('lid');
    if (!lid) {
      var wishlistUrl = page.dataset.wishlistUrl;
      if (wishlistUrl) {
        window.location.replace(wishlistUrl);
        return;
      }
      return;
    }
    loading.hidden = false;
    content.hidden = true;
    unavailable.hidden = true;
    swat.fetchListDetails(
      {
        lid: lid
      },
      function (listDetails) {
        var list = listDetails && listDetails.list;
        var listProps = list && list.lprops;
        var isPublic = listProps && listProps.public === true;
        if (!isPublic) {
          showSharedWishlistUnavailable(loading, content, unavailable);
          return;
        }
        /* Public list.*/
        loading.hidden = true;
        unavailable.hidden = true;
        content.hidden = false;
        var listName = list.lname || 'Wishlist';
        var items = listDetails.items || [];
        if (title) {
          title.textContent = listName;
        }
        var sharedByValue = list?.userinfo?.em;
        if (sharedBy) {
          sharedBy.textContent = 'Shared By: ' + sharedByValue;
        }
        renderSharedWishlistItems(swat, lid, items, grid, empty);
      },
      function (error) {
        console.error('[Shared Wishlist] fetchListDetails error:', error);
        showSharedWishlistUnavailable(loading, content, unavailable);
      }
    );
  }
  function fetchAndRenderWishlistPageLists(swat) {
    var loading = document.getElementById('swym-wishlist-lists-loading');
    var empty = document.getElementById('swym-wishlist-lists-empty');
    var grid = document.getElementById('swym-wishlist-lists-grid');
    var title = document.querySelector('.ms-wishlist-header__title');
    if (!grid) return;
    swat.fetchLists({
      callbackFn: function (lists) {
        customerLists = lists || [];
        if (customerLists.length > 1) {
          title.textContent = 'My Wishlists';
        } else {
          title.textContent = 'My Wishlist';
        }
        if (loading) {
          loading.style.display = 'none';
        }
        var sortedLists = (lists || []).slice().sort(function (a, b) {
          return (a.cts || 0) - (b.cts || 0);
        });
        renderWishlistPageLists(swat, sortedLists, grid, empty);
      },
      errorFn: function (error) {
        if (loading) {
          loading.style.display = 'none';
        }
        console.error('swat.fetchLists error', error);
      }
    });
  }
  function renderWishlistPageLists(swat, lists, grid, emptyEl) {
    grid.innerHTML = '';
    if (!lists.length) {
      if (emptyEl) {
        emptyEl.style.display = '';
      }
      grid.setAttribute('aria-busy', 'false');
      return;
    }
    if (emptyEl) {
      emptyEl.style.display = 'none';
    }
    lists.forEach(function (list) {
      var itemCount = list.cnt != null ? list.cnt : (list.listcontents || []).length;
      var card = document.createElement('div');
      card.className = 'ms-wishlist-list-card';
      card.dataset.lid = list.lid;
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Open ' + (list.lname || 'Untitled list'));
      card.innerHTML = `
        ${buildListCardImagesHTML(list)} 
        <div class="list-card-title-container">
          <h2 class="ms-wishlist-list-card__name">${esc(list.lname)}</h2>
          <button id="list-card-rename-button" class="list-card-rename-button">
            <svg class="icon" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M7.92578 3.36719C8.21245 5.20719 9.70578 6.61385 11.5591 6.80052" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M2 14.666H14" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
		        </svg>
          </button>
        </div>
        <p class="ms-wishlist-list-card__count">${itemCount}${(itemCount === 1 ? ' item' : ' items')}</p>`;
      wireListCardImageFallbacks(card);
      card.addEventListener('click', function () {
        openWishlistListDrawer(swat, list.lid, list.lname);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openWishlistListDrawer(swat, list.lid, list.lname);
        }
      });
      var renameBtn = card.querySelector('.list-card-rename-button');
      if (renameBtn) {
        renameBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          currentDrawerSwat = swat;
          currentDrawerLid = list.lid;
          currentDrawerLname = list.lname;
          currentDrawerList = list;
          renameList();
        });
      }
      grid.appendChild(card);
    });
    grid.setAttribute('aria-busy', 'false');
  }
  function openWishlistListDrawer(swat, lid, lname) {
    var listsSection = document.getElementById('swym-wishlist-content');
    var drawer = document.getElementById('swym-wishlist-drawer');
    var loading = document.getElementById('swym-wishlist-drawer-loading');
    var empty = document.getElementById('swym-wishlist-drawer-empty');
    var grid = document.getElementById('swym-wishlist-drawer-grid');
    if (!listsSection || !drawer || !grid) {
      return;
    }
    currentDrawerSwat = swat;
    var list = customerLists.find(
      function (item) {
        return String(item.lid) === String(lid);
      }
    );
    currentDrawerList = list || {
      lid: lid,
      lname: lname,
      lprops: {
        public: false
      }
    };
    currentDrawerLid = lid;
    currentDrawerLname = lname;
    /* Reset prepared data for the newly opened list.*/
    currentWishlistPreparedData = {
      lid: lid,
      ready: false,
      items: [],
      customizationItems: [],
      outOfStockItems: [],
      addableItems: []
    };
    updateWishlistDrawerHeading(currentDrawerList);
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'true');
    if (empty) {
      empty.style.display = 'none';
    }
    if (loading) {
      loading.style.display = '';
    }
    swapSections(listsSection, drawer);
    swat.fetchListDetails(
      {
        lid: lid
      },
      function (listDetails) {
        if (loading) {
          loading.style.display = 'none';
        }
        var items = (listDetails && listDetails.items) || [];
        if (!items.length) {
          currentWishlistPreparedData.ready = true;
          updateWishlistDrawerActionStates();
          renderWishlistDrawerItems(swat, lid, items, grid, empty);
          return;
        }
        renderWishlistDrawerItems(swat, lid, items, grid, empty);
      },
      function (error) {
        if (loading) {
          loading.style.display = 'none';
        }
        console.error('[Wishlist] swat.fetchListDetails error', error);
        currentWishlistPreparedData.ready = false;
      }
    );
    bindDrawerCloseHandlers();
  }
  function appendNewWishlistDrawerItems(swat, lid) {
    var grid = document.getElementById('swym-wishlist-drawer-grid');
    var empty = document.getElementById('swym-wishlist-drawer-empty');
    if (!grid || !currentDrawerLid || String(currentDrawerLid) !== String(lid)) {
      return;
    }
    swat.fetchListDetails(
      { lid: lid },
      function (listDetails) {
        var items = (listDetails && listDetails.items) || [];
        var currentEpis = new Set(
          items.map(function (item) {
            return String(item.epi);
          })
        );
        var existingEpis = new Set(
          (currentWishlistPreparedData.items || []).map(function (product) {
            return String(product.item.epi);
          })
        );
        var newItems = items.filter(function (item) {
          return !existingEpis.has(String(item.epi));
        });
        var removedProducts = (currentWishlistPreparedData.items || []).filter(function (product) {
          return !currentEpis.has(String(product.item.epi));
        });
        if (removedProducts.length) {
          removedProducts.forEach(function (product) {
            if (product.card) {
              product.card.remove();
            }
          });
          var removedEpis = new Set(
            removedProducts.map(function (product) {
              return String(product.item.epi);
            })
          );
          currentWishlistPreparedData.items = (currentWishlistPreparedData.items || []).filter(function (product) {
            return !removedEpis.has(String(product.item.epi));
          });
        }
        updateDrawerCount(items.length);
        if (currentDrawerList) {
          currentDrawerList = Object.assign({}, currentDrawerList, { cnt: items.length });
          updateWishlistDrawerHeading(currentDrawerList);
        }
        if (!items.length && empty) {
          empty.style.display = '';
        }
        if (!newItems.length) {
          currentWishlistPreparedData.customizationItems = currentWishlistPreparedData.items.filter(function (product) {
            return product.status === 'customize';
          });
          currentWishlistPreparedData.outOfStockItems = currentWishlistPreparedData.items.filter(function (product) {
            return product.status === 'oos';
          });
          currentWishlistPreparedData.addableItems = currentWishlistPreparedData.items.filter(function (product) {
            return product.status === 'atc';
          });
          if (removedProducts.length) {
            updateWishlistDrawerActionStates();
          }
          return;
        }
        Promise.all(newItems.map(fetchProductCardHTML))
          .then(function (cardHTMLs) {
            var enhancePromises = [];
            var newCardNodes = [];
            cardHTMLs.forEach(function (html, index) {
              if (!html) {
                newCardNodes.push(null);
                return;
              }
              var wrapper = document.createElement('div');
              wrapper.innerHTML = html;
              var cardNode = wrapper.firstElementChild;
              newCardNodes.push(cardNode || null);
            });
            for (var i = newCardNodes.length - 1; i >= 0; i--) {
              var cardNode = newCardNodes[i];
              if (!cardNode) {
                continue;
              }
              if (empty) {
                empty.style.display = 'none';
              }
              grid.insertBefore(cardNode, grid.firstChild);
              enhancePromises.push(enhanceDrawerProductCard(cardNode, newItems[i], swat, lid, grid, empty));
            }
            document.dispatchEvent(
              new CustomEvent('shopify:section:load', {
                detail: { sectionId: PRODUCT_CARD_SECTION_ID }
              })
            );
            return Promise.all(enhancePromises);
          })
          .then(function (preparedNewProducts) {
            preparedNewProducts = preparedNewProducts.filter(function (product) {
              return !!product;
            });
            currentWishlistPreparedData.items = (currentWishlistPreparedData.items || []).concat(preparedNewProducts);
            currentWishlistPreparedData.customizationItems = currentWishlistPreparedData.items.filter(function (product) {
              return product.status === 'customize';
            });
            currentWishlistPreparedData.outOfStockItems = currentWishlistPreparedData.items.filter(function (product) {
              return product.status === 'oos';
            });
            currentWishlistPreparedData.addableItems = currentWishlistPreparedData.items.filter(function (product) {
              return product.status === 'atc';
            });
            updateWishlistDrawerActionStates();
            equalizeWishlistCardHeights();
          })
          .catch(function (error) {
            console.error('[Wishlist] Failed appending new drawer items:', error);
          });
      },
      function (error) {
        console.error('[Wishlist] fetchListDetails failed while appending new items:', error);
      }
    );
  }
  function renderWishlistDrawerItems(swat, lid, items, grid, emptyEl) {
    grid.innerHTML = '';
    if (!items.length) {
      if (emptyEl) {
        emptyEl.style.display = '';
      }
      grid.setAttribute('aria-busy', 'false');
      currentWishlistPreparedData.ready = true;
      updateWishlistDrawerActionStates();
      return;
    }
    if (emptyEl) {
      emptyEl.style.display = 'none';
    }
    /* First render all product cards.*/
    Promise.all(
      items.map(fetchProductCardHTML)
    )
      .then(function (cardHTMLs) {
        var enhancePromises = [];
        cardHTMLs.forEach(function (html, index) {
          if (!html) {
            return;
          }
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var cardNode = wrapper.firstElementChild;
          if (!cardNode) {
            return;
          }
          grid.appendChild(cardNode);
          enhancePromises.push(enhanceDrawerProductCard(cardNode, items[index], swat, lid, grid, emptyEl)
          );
        });
        grid.setAttribute('aria-busy', 'false');
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            detail: { sectionId: PRODUCT_CARD_SECTION_ID }
          })
        );
        /* Wait until every product has been processed.*/
        return Promise.all(enhancePromises);
      })
      .then(function (preparedProducts) {
        /* Remove failed/null entries.*/
        preparedProducts = preparedProducts.filter(
          function (product) {
            return !!product;
          }
        );
        /* Build the complete cache.*/
        currentWishlistPreparedData.items = preparedProducts;
        currentWishlistPreparedData.customizationItems = preparedProducts.filter(function (product) {
          return product.status === 'customize';
        });
        currentWishlistPreparedData.outOfStockItems = preparedProducts.filter(function (product) {
          return product.status === 'oos';
        });
        currentWishlistPreparedData.addableItems = preparedProducts.filter(function (product) {
          return product.status === 'atc';
        });
        currentWishlistPreparedData.ready = true;
        setTimeout(() => {
          updateWishlistDrawerActionStates();
        }, 500);
        equalizeWishlistCardHeights();
        currentWishlistPreparedData.outOfStockItems.forEach(
          function (product) {
            if (!product.card) {
              return;
            }
            var button = product.card.querySelector('.ms-wishlist-card__atc-btn');
            if (!button) {
              return;
            }
            button.textContent = 'Out of Stock';
            button.disabled = true;
            delete button.dataset.wishlistPreparing;
            delete button.dataset.bulkCartDisabled;
          }
        );
      })
      .catch(function (error) {
        console.error('[Wishlist] Failed preparing wishlist products:', error);
        currentWishlistPreparedData.ready = false;
      });
  }
  function renderSharedWishlistItems(swat, lid, items, grid, emptyEl) {
    if (!grid) {
      return;
    }
    grid.innerHTML = '';
    grid.setAttribute('aria-busy', 'true');
    if (!items.length) {
      if (emptyEl) {
        emptyEl.hidden = false;
      }
      grid.setAttribute('aria-busy', 'false');
      return;
    }
    if (emptyEl) {
      emptyEl.hidden = true;
    }
    Promise.all(
      items.map(fetchProductCardHTML)
    ).then(function (cardHTMLs) {
      var enhancePromises = [];
      cardHTMLs.forEach(function (html, index) {
        if (!html) {
          return;
        }
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var cardNode = wrapper.firstElementChild;
        if (!cardNode) {
          return;
        }
        grid.appendChild(cardNode);
        enhancePromises.push(enhanceDrawerProductCard(cardNode, items[index], swat, lid, grid, emptyEl, { sharedWishlist: true }));
      });
      grid.setAttribute('aria-busy', 'false');
      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          detail: {
            sectionId: PRODUCT_CARD_SECTION_ID
          }
        })
      );
      equalizeWishlistCardHeights();
      return Promise.all(enhancePromises);
    }).catch(function (error) {
      console.error('[Shared Wishlist] Failed preparing wishlist products:', error);
      grid.setAttribute('aria-busy', 'false');
    });
  }
  function normalizeImageUrl(url) {
    if (!url) return url;
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }
  function getListCardPreviewItems(list) {
    return (list.listcontents || []).filter(function (item) { return item.iu; }).slice(0, 3);
  }
  function buildListCardImagesHTML(list) {
    var previewItems = getListCardPreviewItems(list);
    if (!previewItems.length) {
      return '<div class="ms-wishlist-list-card__images ms-wishlist-list-card__images--empty"></div>';
    }
    var imgsHTML = previewItems.map(function (item) {
      return '<img src="' + esc(normalizeImageUrl(item.iu)) + '" alt="" loading="lazy" data-fallback-du="' + esc(item.du || '') + '">';
    }).join('');
    return '<div class="ms-wishlist-list-card__images ms-wishlist-list-card__images--count-' + previewItems.length + '">' + imgsHTML + '</div>';
  }
  function wireListCardImageFallbacks(card) {
    var imgs = card.querySelectorAll('.ms-wishlist-list-card__images img[data-fallback-du]');
    imgs.forEach(function (img) {
      img.addEventListener('error', function onError() {
        img.removeEventListener('error', onError);
        var du = img.getAttribute('data-fallback-du');
        if (!du) { img.remove(); return; }
        fetchProductJSON(du).then(function (product) {
          var liveImage = product && (product.featured_image || (product.images && product.images[0]));
          if (!liveImage) {
            img.remove();
            return;
          }
          img.addEventListener('error', function onFallbackError() {
            img.removeEventListener('error', onFallbackError);
            img.remove();
          }, { once: true });
          img.src = normalizeImageUrl(liveImage);
        }).catch(function () {
          img.remove();
        });
      });
    });
  }
  function swapSections(hideEl, showEl) {
    hideEl.classList.add('ms-wishlist-section--fading');
    window.setTimeout(function () {
      hideEl.hidden = true;
      hideEl.classList.remove('ms-wishlist-section--fading');
      showEl.hidden = false;
      showEl.classList.add('ms-wishlist-section--fading');
      void showEl.offsetWidth;
      showEl.classList.remove('ms-wishlist-section--fading');
    }, SECTION_TRANSITION_MS);
  }
  function fetchProductCardHTML(item) {
    var parts = String(item.du || '').split('/products/');
    if (parts.length < 2) return Promise.resolve(null);
    var handle = parts[1].split('?')[0];
    var url = window.location.origin + window.Shopify.routes.root + 'products/' + handle + '?variant=' + item.epi + '&section_id=' + PRODUCT_CARD_SECTION_ID;
    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('product-card section fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cardEl = doc.querySelector('.product-card');
        return cardEl ? cardEl.outerHTML : null;
      })
      .catch(function () {
        return null;
      });
  }
  function fetchWishlistMediaHTML(item) {
    var parts = String(item.du || '').split('/products/');
    if (parts.length < 2) return Promise.resolve(null);

    var handle = parts[1].split('?')[0];

    var url =
      window.location.origin +
      window.Shopify.routes.root +
      'products/' +
      handle +
      '?variant=' +
      item.epi +
      '&section_id=' +
      WISHLIST_MEDIA_SECTION_ID;

    return fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('wishlist-media section fetch failed');
        }

        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /*
         * wishlist-media.liquid renders the quick-view-media snippet
         * directly, so return the section HTML itself.
         */
        return doc.body.innerHTML;
      })
      .catch(function (error) {
        console.error('[Wishlist] Failed to fetch media section:', error);
        return null;
      });
  }
  function updateWishlistMediaImage(context, variant) {
    var slider = context._wishlistMediaSlider;
    if (!variant || !variant.featured_media || !slider) {
      return false;
    }
    var elements = getWishlistElements(context);
    if (!elements.media) {
      return false;
    }
    var sliderEl = elements.media.querySelector(".js-quick-view-slider");
    if (!sliderEl) {
      return false;
    }
    var featuredImage = sliderEl.querySelector('[data-img-id="' + variant.featured_media.id + '"]');
    if (!featuredImage) {
      return false;
    }
    var slideIndex = featuredImage.closest('[data-slide-index]').getAttribute('data-slide-index');
    slider.slideTo(slideIndex);
    return true;
  }
  function renderWishlistMedia(context, productData, variantId, requestToken) {
    var elements = getWishlistElements(context);

    if (!elements.media) {
      return Promise.resolve();
    }

    var mediaProduct = {
      du: window.location.origin + productData.url,
      epi: variantId
    };

    elements.media.classList.add('is-loading');

    return fetchWishlistMediaHTML(mediaProduct)
      .then(function (html) {
        if (requestToken !== undefined && context._wishlistRequestToken !== requestToken) {
          return;
        }
        if (!html) {
          return;
        }

        elements.media.innerHTML = html;
        initWishlistMediaCarousel(context);
        /*
         * Let existing Shopify/theme section listeners know that
         * wishlist media has been dynamically inserted.
         */
        elements.media.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: false,
            detail: {
              sectionId: WISHLIST_MEDIA_SECTION_ID
            }
          })
        );
      })
      .finally(function () {
        elements.media.classList.remove('is-loading');
      });
  }
  function fetchProductJSON(du) {
    var parts = String(du || '').split('/products/');
    if (parts.length < 2) return Promise.reject(new Error('invalid product URL'));
    var url = window.location.origin + window.Shopify.routes.root + 'products/' + parts[1].split('?')[0] + '.js';
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('product fetch failed');
      return response.json();
    });
  }
  function buildVariantDetailsText(shopifyProduct, variant) {
    if (!shopifyProduct || !variant || !shopifyProduct.options) return '';
    var parts = [];
    shopifyProduct.options.forEach(function (option, index) {
      var optionName = typeof option === 'string' ? option : (option && option.name);
      if (!optionName || String(optionName).toLowerCase() === 'title') return;
      var value = variant['option' + (index + 1)];
      if (!value) return;
      parts.push(optionName + ' ' + value);
    });
    return parts.join('\n');
  }
  // Adds what the theme's default product-card doesn't have in this context:
  function enhanceDrawerProductCard(cardNode, item, swat, lid, grid, emptyEl, options) {
    var productImage = cardNode.querySelector(".product-card__image");
    options = options || {};
    if (!options.sharedWishlist) {
      attachCardMenu(cardNode, item, swat, lid, grid, emptyEl);
    }
    return fetchProductJSON(item.du)
      .then(function (shopifyProduct) {
        var variant = (shopifyProduct.variants || []).find(
          function (v) {
            return String(v.id) === String(item.epi);
          }
        );
        if (!variant) {
          throw new Error('Wishlist variant not found: ' + item.epi);
        }
        if (productImage) {
          var variantImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src || shopifyProduct?.featured_image || null;
          var imageUrl = variantImage || item.iu;
          if (imageUrl) {
            productImage.src = imageUrl;
            productImage.removeAttribute("srcset");
          }
        }
        var productPriceContainerEl = cardNode.querySelector('.product-card__price');
        if (productPriceContainerEl) {
          var regularPriceEl = productPriceContainerEl.querySelector('.price-item--regular');
          var salePriceEl = productPriceContainerEl.querySelector('.price-item--sale');
          var isOnSale = productPriceContainerEl.querySelector('.price--on-sale');
          if (isOnSale) {
            if (regularPriceEl) {
              regularPriceEl.textContent = formatPrice(variant.compare_at_price);
            }
            if (salePriceEl) {
              salePriceEl.textContent = formatPrice(variant.price);
            }
          } else if (regularPriceEl) {
            regularPriceEl.textContent = formatPrice(variant.price);
          }
        }
        var productJson = cardNode.querySelector('.product-json-data');
        var footer = cardNode.querySelector('.product-card__footer');
        if (!footer) {
          throw new Error('Product card footer not found: ' + item.epi);
        }
        if (!productJson) {
          throw new Error('Product JSON not found: ' + item.epi);
        }
        var data;
        try {
          data = JSON.parse(productJson.textContent);
        } catch (error) {
          throw new Error('Invalid product JSON: ' + item.epi);
        }
        footer.querySelectorAll('.ms-wishlist-card__atc-btn, .product-card__atc-btn, [data-add-to-cart]').forEach(function (button) {
          button.remove();
        });
        var monogramConfiguration = data.variant_monogram ? data.variant_monogram[String(item.epi)] : null;
        var variantText = buildVariantDetailsText(shopifyProduct, variant);
        var existingVariantEl = footer.querySelector('.ms-wishlist-card__variant-details');
        if (!existingVariantEl) {
          var variantEl = document.createElement('p');
          variantEl.className = 'ms-wishlist-card__variant-details';
          footer.appendChild(variantEl);
        }
        if (variantText) {
          variantEl.innerHTML = variantText.replace(/\n/g, '<br>');
        }
        var inStock = variant.available === true;
        var productTitle = item.dt || cardNode.querySelector('.product-card__title')?.textContent?.trim() || shopifyProduct.title || 'Unnamed product';
        if (monogramConfiguration === 'required' || monogramConfiguration === 'optional') {
          var customizeLink = document.createElement('a');
          customizeLink.className = 'button button--primary ms-wishlist-card__atc-btn';
          customizeLink.textContent = 'Customize';
          customizeLink.href = item.du + '?variant=' + encodeURIComponent(item.epi);
          footer.appendChild(customizeLink);
          return {
            item: item,
            card: cardNode,
            title: productTitle,
            status: 'customize',
            shopifyProduct: shopifyProduct,
            variant: variant,
            productJson: data,
            cartItem: null
          };
        }
        if (data.is_gift_card_product === true) {
          var customizeLink = document.createElement('a');
          customizeLink.className = 'button button--primary ms-wishlist-card__atc-btn';
          customizeLink.textContent = 'View Gift Card';
          customizeLink.href = item.du + '?variant=' + encodeURIComponent(item.epi);
          footer.appendChild(customizeLink);
          return {
            item: item,
            card: cardNode,
            title: productTitle,
            status: 'customize',
            shopifyProduct: shopifyProduct,
            variant: variant,
            productJson: data,
            cartItem: null
          };
        }
        if (!inStock) {
          var oosBtn = document.createElement('button');
          oosBtn.type = 'button';
          oosBtn.className = 'button button--primary ms-wishlist-card__atc-btn';
          oosBtn.textContent = 'Out of Stock';
          oosBtn.disabled = true;
          footer.appendChild(oosBtn);
          return {
            item: item,
            card: cardNode,
            title: productTitle,
            status: 'oos',
            shopifyProduct: shopifyProduct,
            variant: variant,
            productJson: data,
            cartItem: null
          };
        }
        var atcBtn = document.createElement('button');
        atcBtn.type = 'button';
        atcBtn.className = 'button button--primary ms-wishlist-card__atc-btn';
        atcBtn.textContent = 'Add to Cart';
        atcBtn.dataset.wishlistPreparing = 'true';
        footer.appendChild(atcBtn);
        /* Individual Add to Cart.*/
        atcBtn.addEventListener('click', function () {
          addToCartViaThemeCartApi(item, shopifyProduct, atcBtn, data, lid);
        });
        return {
          item: item,
          card: cardNode,
          title: productTitle,
          status: 'atc',
          shopifyProduct: shopifyProduct,
          variant: variant,
          productJson: data,
          cartItem: null
        };
      })
      .catch(function (error) {
        console.error('[Wishlist] Failed preparing product:', item, error);
        return null;
      });
  }
  // Uses window.themeCore.CartApi — the theme Cart API 
  function addToCartViaThemeCartApi(item, shopifyProduct, atcBtn, productJson, lid) {
    var CartApi = window.themeCore && window.themeCore.CartApi;
    if (!CartApi) {
      return;
    } var variantFinalSale = productJson && productJson.variant_final_sale ? productJson.variant_final_sale[String(item.epi)] : null;
    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding...';
    var variantLeadTime = productJson && productJson.variant_lead_time ? productJson.variant_lead_time[String(item.epi)] : null;
    getCartToken().then(function (cartToken) {
      var cartItem = {
        id: Number(item.epi),
        quantity: 1,
        'properties[_category]': (shopifyProduct && shopifyProduct.type) || '',
        'properties[Shipping Note]': variantLeadTime > 1 ? `Ships within ${variantLeadTime} days` : `Ships within ${variantLeadTime} day`,
        'properties[__product_vendor]': (shopifyProduct && shopifyProduct.vendor) || '',
        'properties[__shipping_lead_time_days]': `${variantLeadTime}`,
        'properties[Return Policy]': variantFinalSale ? 'Final sale items are not returnable' : '',
        'properties[_estimated_shipping_days]': productJson.estimated_shipping_days,
        'properties[_cart_ID]': cartToken,
      };
      return CartApi.makeRequest(CartApi.actions.ADD_TO_CART, cartItem);
    }).then(function () {
      return CartApi.makeRequest(CartApi.actions.GET_CART);
    }).then(function () {
      atcBtn.textContent = 'Added!';
      window.setTimeout(function () {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      }, 2000);
      const eventName = 'wishlist_atc';
      const properties = {
        product_id: item.empi,
        variant_id: item.epi,
        list_id: lid,
        atc_type: 'single'
      };
      trackAmplitudeEvent(eventName, properties);
      trackKlaviyoEvent(eventName, properties);
    }).catch(function (error) {
      showWishlistToast(null, 'message', error.message);
      atcBtn.textContent = 'Not Added to Cart';
      atcBtn.disabled = false;
      setTimeout(() => {
        atcBtn.textContent = 'Add to Cart';
      }, 2000);
    });
  }
  function getCartToken() {
    if (window.themeCore.cartObject && window.themeCore.cartObject.token) {
      return Promise.resolve(
        window.themeCore.cartObject.token
      );
    }
    if (wishlistCartTokenPromise) {
      return wishlistCartTokenPromise;
    }
    wishlistCartTokenPromise = window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART, { noOpen: true })
      .then(function (cart) {
        return cart.token;
      })
      .catch(function (error) {
        wishlistCartTokenPromise = null;
        throw error;
      });
    return wishlistCartTokenPromise;
  }
  function attachCardMenu(cardNode, item, swat, lid, grid, emptyEl) {
    var imageWrapper = cardNode.querySelector('.product-card__main, .product-card__image-wrapper');
    if (!imageWrapper) return;
    imageWrapper.insertAdjacentHTML(
      'beforeend',
      '<div class="ms-wishlist-card-menu">' +
      '<button type="button" class="ms-wishlist-card-menu__btn" aria-haspopup="true" aria-expanded="false" aria-label="Item options">&#8942;</button>' +
      '<div class="ms-wishlist-card-menu__list" role="menu" hidden>' +
      '<button type="button" class="ms-wishlist-card-menu__item" data-action="add-to-list" role="menuitem">Add to List</button>' +
      '<button type="button" class="ms-wishlist-card-menu__item ms-wishlist-card-menu__item--danger" data-action="delete" role="menuitem">Delete from Wishlist</button>' +
      '</div>' +
      '</div>'
    );
    var wrapper = cardNode.querySelector('.ms-wishlist-card-menu');
    var btn = wrapper.querySelector('.ms-wishlist-card-menu__btn');
    var menu = wrapper.querySelector('.ms-wishlist-card-menu__list');
    /* Open / close item menu*/
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = !menu.hidden;
      document.querySelectorAll('.ms-wishlist-card-menu__list').forEach(function (m) {
        m.hidden = true;
      });
      document.querySelectorAll('.ms-wishlist-card-menu__btn').forEach(function (menuBtn) {
        menuBtn.setAttribute('aria-expanded', 'false');
      });
      menu.hidden = isOpen;
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
    /* Handle menu actions*/
    menu.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var actionBtn = e.target.closest('[data-action]');
      if (!actionBtn) return;
      var action = actionBtn.dataset.action;
      /* Close the menu immediately.*/
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      /* ---------------------------------------------------------
       * ADD TO LIST
       * ---------------------------------------------------------*/
      if (action === 'add-to-list') {
        var wishlistModal = document.getElementById('wishlist-modal');
        if (!wishlistModal) {
          return;
        }
        let cprops = {
          storefront_context: item.cprops.storefront_context,
          date: item.cprops.date,
          source: 'wishlist'
        }
        currentWishlistProduct = {
          epi: item.epi,
          empi: item.empi,
          du: item.du,
          dt: item.dt,
          iu: item.iu,
          pr: item.pr,
          cprops: cprops
        };
        const requestToken = ++wishlistRequestToken;
        showWishlistPageLoader();
        currentWishlistButton = null;
        const productURL = item.du;
        fetchProductJSON(productURL)
          .then(function (productData) {
            if (requestToken !== wishlistRequestToken) {
              return;
            }
            if (customerLists.length) {
              return openWishlist(wishlistModal, productData, actionBtn, requestToken);
            }
            return new Promise(function (resolve) {
              loadCustomerLists(function () {
                if (requestToken !== wishlistRequestToken) {
                  resolve();
                  return;
                }
                resolve(openWishlist(wishlistModal, productData, actionBtn, requestToken));
              });
            });
          })
          .catch(function (error) {
            console.error("[Wishlist] Failed to fetch product data:", error);
          })
          .finally(function () {
            if (requestToken === wishlistRequestToken) {
              hideWishlistPageLoader();
            }
          });
        return;
      }
      /*---------------------------------------------------------
      * DELETE FROM WISHLIST
      * ---------------------------------------------------------*/
      if (actionBtn.dataset.action === 'delete') {
        deleteItemWithConfirm(swat, lid, item,
          function () {
            cardNode.remove();
            var remaining = grid.querySelectorAll('.product-card').length;
            updateDrawerCount(remaining);
            if (remaining === 0 && emptyEl) {
              emptyEl.style.display = '';
            }
            var removedId = String(item.epi);
            currentWishlistPreparedData.items = currentWishlistPreparedData.items.filter(function (product) {
              return String(product.item.epi) !== removedId;
            });
            currentWishlistPreparedData.addableItems = currentWishlistPreparedData.addableItems.filter(function (product) {
              return String(product.item.epi) !== removedId;
            });
            currentWishlistPreparedData.outOfStockItems = currentWishlistPreparedData.outOfStockItems.filter(function (product) {
              return String(product.item.epi) !== removedId;
            });
            currentWishlistPreparedData.customizationItems = currentWishlistPreparedData.customizationItems.filter(function (product) {
              return String(product.item.epi) !== removedId;
            });
            updateWishlistDrawerActionStates();
            showWishlistToast(
              {
                iu: item.iu,
                dt: item.dt
              },
              "removed"
            );
          }
        );
      }
    });
  }
  function updateDrawerCount(remaining) {
    var countEl = document.getElementById('swym-wishlist-drawer-count');
    if (countEl) countEl.textContent = remaining + (remaining === 1 ? ' item' : ' items');
  }
  function closeListDrawer() {
    var listsSection = document.getElementById('swym-wishlist-content');
    var drawer = document.getElementById('swym-wishlist-drawer');
    if (!listsSection || !drawer) {
      return;
    }
    var swat = currentDrawerSwat || swymInstance;
    swapSections(drawer, listsSection);
    if (swat) {
      fetchAndRenderWishlistPageLists(swat);
    }
    document.removeEventListener('keydown', handleDrawerKeydown);
  }
  function handleDrawerKeydown(e) {
    if (e.key === 'Escape') closeListDrawer();
  }
  function bindDrawerCloseHandlers() {
    document.addEventListener('keydown', handleDrawerKeydown);
    if (drawerHandlersBound) return;
    drawerHandlersBound = true;
    var backBtn = document.getElementById('swym-wishlist-drawer-back');
    if (backBtn) backBtn.addEventListener('click', closeListDrawer);
    var deleteBtn = document.getElementById('swym-wishlist-drawer-delete');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function () {
        deleteListWithConfirm(currentDrawerSwat, currentDrawerLid, currentDrawerLname, function () {
          closeListDrawer();
        });
      });
    }
    var shareBtn = document.getElementById('swym-wishlist-drawer-share');
    if (shareBtn) {
      shareBtn.addEventListener('click', function (event) {
        shareList();
      });
    }
    var RenameBtn = document.getElementById('swym-wishlist-drawer-rename');
    if (RenameBtn) {
      RenameBtn.addEventListener('click', function (event) {
        renameList();
      });
    }
    bindDrawerMoreOptions();
  }
  function renameList() {
    var list = getCurrentDrawerList();
    if (!list) {
      return;
    }
    openGlobalCreateList('rename', list);
  }
  function deleteListWithConfirm(swat, lid, lname, onDeleted) {
    showConfirmModal({
      title: 'Delete "' + (lname || 'this list') + '"?',
      message: 'Deleting this list can\'t be undone.',
      confirmLabel: 'Delete',
      onConfirm: function () {
        swat.deleteList(lid, function () {
          if (onDeleted) onDeleted();
        }, function (error) {
          console.error('swat.deleteList error', error);
          window.alert('Something went wrong deleting this list. Please try again.');
        });
      }
    });
  }
  function deleteItemWithConfirm(swat, lid, item, onDeleted) {
    showConfirmModal({
      title: 'Remove this item?',
      message: 'Removing this item from your wishlist can\'t be undone.',
      confirmLabel: 'Delete',
      onConfirm: function () {
        swat.deleteFromList(lid, { epi: item.epi, empi: item.empi, du: item.du }, function () {
          if (onDeleted) onDeleted();
          const eventName = 'wishlist_item_removed';
          const properties = {
            product_id: item.empi,
            variant_id: item.epi,
            list_id: lid
          };
          trackAmplitudeEvent(eventName, properties);
          trackKlaviyoEvent(eventName, properties);
        }, function (error) {
          console.error('swat.deleteFromList error', error);
          window.alert('Something went wrong removing this item. Please try again.');
        });
      }
    });
  }
  // Reusable confirm/cancel modal for anything destructive 
  function showConfirmModal(options) {
    var overlay = document.getElementById('swym-confirm-modal-overlay');
    var modal = document.getElementById('swym-confirm-modal');
    var titleEl = document.getElementById('swym-confirm-modal-title');
    var messageEl = document.getElementById('swym-confirm-modal-message');
    var cancelBtn = document.getElementById('swym-confirm-modal-cancel');
    var confirmBtn = document.getElementById('swym-confirm-modal-confirm');
    if (!overlay || !modal || !cancelBtn || !confirmBtn) return;
    titleEl.textContent = options.title || 'Are you sure?';
    messageEl.textContent = options.message || 'This action can\'t be undone.';
    confirmBtn.textContent = options.confirmLabel || 'Delete';
    overlay.hidden = false;
    modal.hidden = false;
    function cleanup() {
      overlay.hidden = true;
      modal.hidden = true;
      cancelBtn.removeEventListener('click', onCancel);
      confirmBtn.removeEventListener('click', onConfirmClick);
      overlay.removeEventListener('click', onCancel);
      document.removeEventListener('keydown', onKeydown);
    }
    function onCancel() { cleanup(); }
    function onConfirmClick() { cleanup(); options.onConfirm(); }
    function onKeydown(e) { if (e.key === 'Escape') onCancel(); }
    cancelBtn.addEventListener('click', onCancel);
    confirmBtn.addEventListener('click', onConfirmClick);
    overlay.addEventListener('click', onCancel);
    document.addEventListener('keydown', onKeydown);
  }
  document.addEventListener('click', function () {
    document.querySelectorAll('.ms-wishlist-card-menu__list').forEach(function (m) { m.hidden = true; });
    closeDrawerMoreOptions();
  });
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function bindDrawerMoreOptions() {
    var moreBtn = document.getElementById('swym-wishlist-drawer-more');
    var moreMenu = document.getElementById('swym-wishlist-drawer-more-menu');
    var editListBtn = document.getElementById('swym-wishlist-drawer-edit-list');
    var addAllBtn = document.getElementById('swym-wishlist-drawer-add-all');
    var removeOosBtn = document.getElementById('swym-wishlist-drawer-remove-oos');
    if (!moreBtn || !moreMenu) {
      return;
    }
    if (moreBtn.dataset.bound === 'true') {
      return;
    }
    moreBtn.dataset.bound = 'true';
    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = !moreMenu.hidden;
      moreMenu.hidden = isOpen;
      moreBtn.setAttribute('aria-expanded', String(!isOpen));
    });
    /* Edit List */
    if (editListBtn) {
      editListBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawerMoreOptions();
        var list = getCurrentDrawerList();
        if (!list) {
          return;
        }
        openGlobalCreateList('edit', list);
      }
      );
    }
    /* Add All */
    if (addAllBtn) {
      addAllBtn.addEventListener('click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawerMoreOptions();
          addAllItemsToCart();
        }
      );
    }
    /* Remove OOS */
    if (removeOosBtn) {
      removeOosBtn.addEventListener('click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawerMoreOptions();
          removeAllOutOfStockItems();
        }
      );
    }
  }
  function closeDrawerMoreOptions() {
    var moreBtn = document.getElementById('swym-wishlist-drawer-more');
    var moreMenu = document.getElementById('swym-wishlist-drawer-more-menu');
    if (!moreMenu) return;
    moreMenu.hidden = true;
    if (moreBtn) {
      moreBtn.setAttribute('aria-expanded', 'false');
    }
  }
  function addAllItemsToCart() {
    var customizationItems = currentWishlistPreparedData.customizationItems || [];
    var outOfStockItems = currentWishlistPreparedData.outOfStockItems || [];
    var addableItems = currentWishlistPreparedData.addableItems || [];
    /*------------------------------------------------
     * SHOW THE RESULT MODAL IMMEDIATELY
     * ------------------------------------------------
     * ATC products show "Adding..."
     * before the cart request starts.*/
    showWishlistBulkResult(
      {
        addedItems: addableItems,
        customizationItems: customizationItems,
        outOfStockItems: outOfStockItems,
        failedItems: []
      },
      true
    );
    /* GET CART TOKEN */
    getCartToken().then(function (cartToken) {
      var preparedItems = addableItems.map(function (product) {
        var item = product.item;
        var shopifyProduct = product.shopifyProduct || {};
        var data = product.productJson || {};
        var variantFinalSale = data.variant_final_sale ? data.variant_final_sale[String(item.epi)] : null;
        var variantLeadTime = data.variant_lead_time ? data.variant_lead_time[String(item.epi)] : null;
        var cartItem = {
          id: Number(item.epi),
          quantity: 1,
          'properties[_category]': (shopifyProduct && shopifyProduct.type) || '',
          'properties[Shipping Note]': variantLeadTime > 1 ? `Ships within ${variantLeadTime} days` : `Ships within ${variantLeadTime} day`,
          'properties[__product_vendor]': (shopifyProduct && shopifyProduct.vendor) || '',
          'properties[__shipping_lead_time_days]': `${variantLeadTime}`,
          'properties[Return Policy]': variantFinalSale ? 'Final sale items are not returnable' : '',
          'properties[_estimated_shipping_days]': data.estimated_shipping_days,
          'properties[_cart_ID]': cartToken,
        };
        return {
          item: item,
          card: product.card,
          title: product.title || item.dt || 'Unnamed product',
          status: 'atc',
          shopifyProduct: shopifyProduct,
          variant: product.variant,
          productJson: data,
          cartItem: cartItem
        };
      });
      return addWishlistItemsToCart(preparedItems);
    })
      .then(function (result) {
        var failedItems = result.failedItems || [];
        var addedItems = addableItems.filter(function (product) {
          var isFailed = failedItems.some(function (failedProduct) {
            return String(failedProduct.item.epi) === String(product.item.epi);
          });
          return !isFailed;
        });
        addedItems.forEach(function (product) {
          const eventName = 'wishlist_atc';
          const properties = {
            product_id: product.item.empi,
            variant_id: product.item.epi,
            list_id: currentWishlistPreparedData.lid,
            atc_type: 'full'
          };
          trackAmplitudeEvent(eventName, properties);
          trackKlaviyoEvent(eventName, properties);
        });
        result.addedItems = addableItems;
        result.customizationItems = customizationItems;
        result.outOfStockItems = outOfStockItems;
        showWishlistBulkResult(result, false);
      })
      .catch(function (error) {
        console.error('[Wishlist] Add all items to cart failed:', error);
        var failedItems = addableItems.map(function (product) {
          return {
            item: product.item,
            card: product.card,
            title: product.title || product.item?.dt || 'Unnamed product',
            error: error
          };
        });
        showWishlistBulkResult(
          {
            addedItems: addableItems,
            customizationItems: customizationItems,
            outOfStockItems: outOfStockItems,
            failedItems: failedItems
          },
          false
        );
      });
  }
  function updateWishlistDrawerActionStates() {
    var addAllBtn = document.getElementById('swym-wishlist-drawer-add-all');
    var removeOosBtn = document.getElementById('swym-wishlist-drawer-remove-oos');
    var addableItems = currentWishlistPreparedData.addableItems || [];
    var outOfStockItems = currentWishlistPreparedData.outOfStockItems || [];
    if (addAllBtn) {
      addAllBtn.disabled = addableItems.length === 0;
    }
    if (removeOosBtn) {
      removeOosBtn.disabled = outOfStockItems.length === 0;
    }
  }
  function removeAllOutOfStockItems() {
    var outOfStockItems = currentWishlistPreparedData.outOfStockItems || [];
    if (!outOfStockItems.length) {
      return;
    }
    var deletePromises = outOfStockItems.map(function (product) {
      return new Promise(function (resolve, reject) {
        currentDrawerSwat.deleteFromList(
          currentDrawerLid,
          {
            epi: product.item.epi,
            empi: product.item.empi,
            du: product.item.du
          },
          function () {
            resolve(product);
            const eventName = 'wishlist_item_removed';
            const properties = {
              product_id: product.item.empi,
              variant_id: product.item.epi,
              list_id: currentDrawerLid
            };
            trackAmplitudeEvent(eventName, properties);
            trackKlaviyoEvent(eventName, properties);
          },
          function (error) {
            reject({
              product: product,
              error: error
            });
          }
        );
      });
    });
    Promise.allSettled(deletePromises)
      .then(function (results) {
        var successfulItems = [];
        var failedItems = [];
        results.forEach(function (result) {
          if (result.status === 'fulfilled') {
            successfulItems.push(result.value);
          } else {
            failedItems.push(result.reason);
          }
        });
        successfulItems.forEach(function (product) {
          if (product.card) {
            product.card.remove();
          }
        });
        var removedIds = new Set(
          successfulItems.map(function (product) {
            return String(
              product.item.epi
            );
          })
        );
        currentWishlistPreparedData.items = currentWishlistPreparedData.items.filter(
          function (product) {
            return !removedIds.has(
              String(product.item.epi)
            );
          }
        );
        currentWishlistPreparedData.outOfStockItems = currentWishlistPreparedData.outOfStockItems.filter(
          function (product) {
            return !removedIds.has(
              String(product.item.epi)
            );
          }
        );
        var remaining = currentWishlistPreparedData.items.length;
        updateDrawerCount(remaining);
        var emptyEl = document.getElementById('swym-wishlist-drawer-empty');
        if (remaining === 0 && emptyEl) {
          emptyEl.style.display = '';
        }
        updateWishlistDrawerActionStates();
        if (!failedItems.length) {
          showWishlistToast(null, 'oos-removed');
          return;
        }
        showWishlistToast(null, 'message', 'Some out of stock items could not be removed.');
      })
      .catch(function (error) {
        console.error('[Wishlist] Remove OOS failed:', error);
      });
  }
  function addWishlistItemsToCart(preparedItems) {
    if (!Array.isArray(preparedItems) || !preparedItems.length) {
      return Promise.resolve({
        failedItems: []
      });
    }
    const items = preparedItems.map(function (product) {
      const sourceCartItem = product.cartItem || {};
      const properties = {};
      Object.keys(sourceCartItem).forEach(function (key) {
        if (key.indexOf("properties[") === 0) {
          const propertyName = key.replace(/^properties\[/, "").replace(/\]$/, "");
          const propertyValue = sourceCartItem[key];
          if (propertyValue !== '' && propertyValue !== null && propertyValue !== undefined) {
            properties[propertyName] = propertyValue;
          }
        }
      });
      const cartItem = {
        id: Number(sourceCartItem.id),
        quantity: Number(sourceCartItem.quantity) || 1
      };
      if (Object.keys(properties).length) {
        cartItem.properties = properties;
      }
      return cartItem;
    });
    /* Validate every item before making the request.*/
    const invalidItems = [];
    items.forEach(function (cartItem, index) {
      if (!cartItem.id || Number.isNaN(cartItem.id)) {
        invalidItems.push({
          index: index,
          product: preparedItems[index],
          reason: "Invalid variant ID"
        });
      }
    });
    if (invalidItems.length) {
      console.error("[Wishlist] Invalid products found before bulk cart request:", invalidItems);
      return Promise.resolve({
        failedItems: invalidItems.map(function (invalidItem) {
          return {
            item: invalidItem.product.item,
            card: invalidItem.product.card,
            title: invalidItem.product.title || invalidItem.product.item?.dt || "Unnamed product",
            error: new Error(invalidItem.reason)
          };
        })
      });
    }
    const payload = { items: items };
    return fetch(
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      }
    ).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          const error = new Error(data?.description || data?.message || "Unable to add wishlist products to cart.");
          error.status = response.status;
          error.response = data;
          throw error;
        }
        return data;
      });
    }).then(function (data) {
      if (window.themeCore && window.themeCore.CartApi && window.themeCore.CartApi.actions && window.themeCore.CartApi.actions.GET_CART) {
        return window.themeCore.CartApi.makeRequest(
          window.themeCore.CartApi.actions.GET_CART
        ).then(function (cart) {
          return {
            failedItems: [],
            cart: cart
          };
        })
          .catch(function (error) {
            console.warn("[Wishlist] Cart refresh failed after successful bulk add:", error
            );
            return {
              failedItems: []
            };
          });
      }
      return {
        failedItems: []
      };
    })
      .catch(function (error) {
        console.error("[Wishlist] Bulk cart request failed:", error);
        console.error("[Wishlist] Bulk cart payload:", payload);
        return {
          failedItems: preparedItems.map(function (product) {
            return {
              item: product.item,
              card: product.card,
              title: product.title || product.item?.dt || "Unnamed product",
              error: error
            };
          })
        };
      });
  }
  function showWishlistBulkResult(result, isLoading) {
    const customizationItems = result.customizationItems || [];
    const outOfStockItems = result.outOfStockItems || [];
    const addedItems = result.addedItems || [];
    const failedItems = result.failedItems || [];
    function getBulkResultProductImage(product) {
      var imageUrl = '';
      if (product.card) {
        var cardImage = product.card.querySelector('.product-card__image');
        if (cardImage) {
          imageUrl = cardImage.currentSrc || cardImage.src || '';
        }
      }
      if (!imageUrl && product.variant) {
        imageUrl = product.variant.featured_image?.src || product.variant.featured_media?.preview_image?.src || '';
      }
      if (!imageUrl && product.shopifyProduct) {
        imageUrl = product.shopifyProduct.featured_image || product.shopifyProduct.images?.[0] || '';
      }
      if (!imageUrl && product.item) {
        imageUrl = product.item.iu || '';
      }
      return normalizeImageUrl(imageUrl);
    }
    const existingModal = document.querySelector(".wishlist-bulk-result-modal");
    if (existingModal && !isLoading) {
      const failedIds = new Set(failedItems.map(function (product) {
        return String(product.item.epi);
      })
      );
      existingModal.querySelectorAll(".wishlist-bulk-result__product[data-epi]").forEach(function (productRow) {
        const epi = productRow.dataset.epi;
        const statusButton = productRow.querySelector(".wishlist-bulk-result__product-status");
        if (!statusButton) {
          return;
        }
        statusButton.textContent = failedIds.has(String(epi)) ? "Not added to cart" : "Added to cart";
      });
      return;
    }
    if (existingModal) {
      existingModal.remove();
    }
    let sectionsHTML = "";
    // ADDED PRODUCTS
    if (addedItems.length) {
      sectionsHTML += `
        <div class="wishlist-bulk-result__section">
          <h5>${esc(wishlistTranslations.addedProduct)}</h5>
          <div class="wishlist-bulk-result__products">
            ${addedItems.map(function (product) {
        const isFailed = failedItems.some(function (failedProduct) {
          return (String(failedProduct.item.epi) === String(product.item.epi));
        });
        const statusText = isLoading ? (wishlistTranslations.addingToCart || 'Adding...') : isFailed ? (wishlistTranslations.notAddedToCart || 'Not added to cart') : (wishlistTranslations.addedToCart || 'Added to cart');
        return `
                  <div class="wishlist-bulk-result__product" data-epi="${esc(product.item.epi)}">
                    <div class="wishlist-bulk-result__product-main">
                      <img class="wishlist-bulk-result__product-image" src="${esc(getBulkResultProductImage(product) || "")}" alt="${esc(product.title)}" >
                      <p class="wishlist-bulk-result__product-title">${esc(product.title)}</p>
                    </div>
                    <span class="button wishlist-bulk-result__product-status">${statusText}</span>
                  </div>
                `;
      }).join("")}
          </div>
        </div>
      `;
    }
    // CUSTOMIZATION REQUIRED
    if (customizationItems.length) {
      sectionsHTML += `
        <div class="wishlist-bulk-result__section">
          <h5>${esc(wishlistTranslations.customizationRequiredProduct || 'Customization Required Product')}</h5>
          <p>${esc(wishlistTranslations.customizationRequiredDescription || 'Below products are not added to cart due to customization requirements.')}</p>
          <div class="wishlist-bulk-result__products">
            ${customizationItems.map(function (product) {
        return `
                  <div class="wishlist-bulk-result__product">
                    <div class="wishlist-bulk-result__product-main">
                      <img class="wishlist-bulk-result__product-image" src="${esc(getBulkResultProductImage(product) || "")}" alt="${esc(product.title)}" >
                      <p class="wishlist-bulk-result__product-title">${esc(product.title)}</p>
                    </div>
                    <span class="wishlist-bulk-result__product-status">${esc(wishlistTranslations.notAddedToCart)}</span>
                  </div>
                `;
      })
          .join("")}
          </div>
        </div>
      `;
    }
    // OUT OF STOCK
    if (outOfStockItems.length) {
      sectionsHTML += `
        <div class="wishlist-bulk-result__section">
          <h5>${esc(wishlistTranslations.outOfStockProduct || 'Out of stock Products')}</h5>
          <p>${esc(wishlistTranslations.outOfStockProductDescription || 'Below products are not added to cart due to its unavailability.')}</p>
          <div class="wishlist-bulk-result__products">
            ${outOfStockItems.map(function (product) {
        return `
                  <div class="wishlist-bulk-result__product">
                    <div class="wishlist-bulk-result__product-main">
                      <img class="wishlist-bulk-result__product-image" src="${esc(getBulkResultProductImage(product) || "")}" alt="${esc(product.title)}">
                      <p class="wishlist-bulk-result__product-title">${esc(product.title)}</p>
                    </div>
                    <span class="wishlist-bulk-result__product-status">${esc(wishlistTranslations.notAddedToCart)}</span>
                  </div>
                `;
      }).join("")}
          </div>
        </div>
      `;
    }
    if (!sectionsHTML) {
      return;
    }
    const modal = document.createElement("div");
    modal.className = "wishlist-modal wishlist-global-create-modal wishlist-bulk-result-modal";
    modal.innerHTML = `
      <div class="wishlist-modal__overlay"></div>
      <div class="wishlist-modal__dialog wishlist-bulk-result-modal__dialog">
        <button type="button" class="wishlist-modal__close wishlist-bulk-result-modal__close" aria-label="Close">×</button>
        <div class="wishlist-bulk-result-modal__content">${sectionsHTML}</div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.classList.add("is-open");
    const closeBtn = modal.querySelector(".wishlist-bulk-result-modal__close");
    const overlay = modal.querySelector(".wishlist-modal__overlay");
    function closeModal() {
      modal.classList.remove("is-open");
      modal.remove();
      document.removeEventListener("keydown", handleKeydown);
    }
    function handleKeydown(e) {
      if (e.key === "Escape") {
        closeModal();
      }
    }
    closeBtn?.addEventListener("click", closeModal);
    overlay?.addEventListener("click", closeModal);
  }
  function getCurrentDrawerList() {
    if (currentDrawerList) {
      return currentDrawerList;
    }
    return customerLists.find(function (list) {
      return String(list.lid) === String(currentDrawerLid);
    }) || null;
  }
  function isListPublic(list) {
    return list?.lprops?.public === true;
  }
  function updateWishlistDrawerHeading(list) {
    var titleEl = document.getElementById('swym-wishlist-drawer-title');
    var statusEl = document.getElementById('swym-wishlist-drawer-status');
    if (!titleEl) {
      return;
    }
    var name = list?.lname || currentDrawerLname || 'Wishlist';
    titleEl.textContent = name;
    if (!statusEl) return;
    var isPublic = isListPublic(list);
    var status = isPublic ? 'Public' : 'Private';
    var itemCount = list?.cnt || 0;
    var itemText = itemCount === 1 ? 'Item' : 'Items';
    var globeIcon = `
      <svg class="swym-wishlist-status-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="9.5" stroke="currentColor" stroke-width="2" />
        <path d="M2.5 12H21.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M12 2.5C14.5 5.1 15.8 8.4 15.8 12C15.8 15.6 14.5 18.9 12 21.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M12 2.5C9.5 5.1 8.2 8.4 8.2 12C8.2 15.6 9.5 18.9 12 21.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M4.1 7.5H19.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        <path d="M4.1 16.5H19.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `;
    var lockIcon = `
      <svg class="swym-wishlist-status-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="4.5" y="10" width="15" height="11" rx="2" stroke="currentColor" stroke-width="2"/>
        <path d="M8 10V7.5C8 5.01 9.79 3 12 3C14.21 3 16 5.01 16 7.5V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="15.5" r="1.25" fill="currentColor" />
        <path d="M12 16.75V18.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    `;
    statusEl.className = 'swym-wishlist-drawer-status ' + (isPublic ? 'is-public' : 'is-private');
    statusEl.innerHTML = `
      <span class="swym-wishlist-status-icon-wrapper">${isPublic ? globeIcon : lockIcon}</span>
      <span class="swym-wishlist-status-text">${status}</span>
      <span class="swym-wishlist-status-separator">·</span>
      <span id="swym-wishlist-drawer-count" class='ms-wishlist-drawer__count'>${itemCount} ${itemText}</span>
    `;
  }
  function buildSharedWishlistUrl(lid) {
    const elements = getShareModalElements();
    var configuredUrl = elements.modal.dataset.sharedPage;
    if (!configuredUrl || !lid) {
      return '';
    }
    return configuredUrl + '?lid=' + encodeURIComponent(lid);
  }
  function getShareModalElements() {
    return {
      modal: document.getElementById('swym-share-list-modal'),
      overlay: document.querySelector('#swym-share-list-modal .swym-share-list-modal__overlay'),
      close: document.getElementById('swym-share-list-modal-close'),
      url: document.getElementById('swym-share-list-url'),
      copy: document.getElementById('swym-share-list-copy'),
      defaultLabel: document.querySelector('.swym-share-list-copy__default'),
      copiedLabel: document.querySelector('.swym-share-list-copy__copied'),
      privateNote: document.getElementById('swym-share-list-modal-private-note'),
      error: document.getElementById('swym-share-list-modal-error')
    };
  }
  function openShareListModal(shareUrl, showPrivateNote) {
    var elements = getShareModalElements();
    if (!elements.modal) {
      return;
    }
    if (elements.url) {
      elements.url.value = shareUrl || '';
    }
    if (elements.privateNote) {
      elements.privateNote.hidden = !showPrivateNote;
    }
    if (elements.error) {
      elements.error.hidden = true;
      elements.error.textContent = '';
    }
    resetShareCopyButton();
    elements.modal.hidden = false;
  }
  function closeShareListModal() {
    var elements = getShareModalElements();
    if (!elements.modal) {
      return;
    }
    elements.modal.hidden = true;
    if (elements.url) {
      elements.url.value = '';
    }
    if (elements.privateNote) {
      elements.privateNote.hidden = true;
    }
    if (elements.error) {
      elements.error.hidden = true;
      elements.error.textContent = '';
    }
    resetShareCopyButton();
  }
  function resetShareCopyButton() {
    var elements = getShareModalElements();
    if (!elements.defaultLabel || !elements.copiedLabel) {
      return;
    }
    elements.defaultLabel.hidden = false;
    elements.copiedLabel.hidden = true;
  }
  function showShareListError(error) {
    var elements = getShareModalElements();
    if (!elements.error) {
      return;
    }
    elements.error.textContent = elements.error.dataset.message || 'We couldn\'t update your list privacy. Please try again.';
    elements.error.hidden = false;
  }
  function copyShareListUrl() {
    var elements = getShareModalElements();
    if (!elements.url) {
      return;
    }
    var url = elements.url.value;
    if (!url) {
      return;
    }
    trackAmplitudeEvent('wishlist_list_shared', {
      list_id: currentWishlistPreparedData.lid,
      share_url: elements.url.value
    });
    function copySuccessful() {
      if (!elements.defaultLabel || !elements.copiedLabel) {
        return;
      }
      elements.defaultLabel.hidden = true;
      elements.copiedLabel.hidden = false;
      window.setTimeout(function () {
        resetShareCopyButton();
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(copySuccessful)
        .catch(function () {
          fallbackCopyShareListUrl(elements.url, copySuccessful);
        });
      return;
    }
    fallbackCopyShareListUrl(elements.url, copySuccessful);
  }
  function fallbackCopyShareListUrl(input, callback) {
    input.focus();
    input.select();
    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      console.error('[Wishlist] Clipboard copy failed:', error);
    }
    input.setSelectionRange(0, 0);
    if (copied && callback) {
      callback();
    }
  }
  function syncLocalListPublicState(lid, publicStatus) {
    customerLists = customerLists.map(function (customerList) {
      if (String(customerList.lid) === String(lid)) {
        return Object.assign({}, customerList, { lprops: { public: publicStatus } });
      }
      return customerList;
    });
    if (currentDrawerList && String(currentDrawerList.lid) === String(lid)) {
      currentDrawerList = Object.assign({}, currentDrawerList, { lprops: { public: publicStatus } });
    }
  }
  function markListPublicOnSwym(list) {
    return new Promise(function (resolve, reject) {
      if (!list?.lid) {
        reject(new Error('Wishlist list ID is missing.'));
        return;
      }
      swymInstance.markListPublic(
        list.lid,
        function (response) {
          syncLocalListPublicState(list.lid, true);
          resolve(response);
        },
        function (error) {
          console.error('[Wishlist] markListPublic FAILED:', error);
          reject(error);
        }
      );
    });
  }
  function updateListPublicStatus(list, publicStatus) {
    return new Promise(
      function (resolve, reject) {
        if (!list?.lid) {
          reject(new Error('Wishlist list ID is missing.'));
          return;
        }
        swymInstance.updateList(
          {
            lid: list.lid,
            lname: list.lname,
            lprops: {
              public: publicStatus
            }
          },
          function (response) {
            syncLocalListPublicState(list.lid, publicStatus);
            resolve(response);
          },
          function (error) {
            reject(error);
          }
        );
      }
    );
  }
  function shareList() {
    var list = getCurrentDrawerList();
    if (!list) {
      return;
    }
    var shareUrl = buildSharedWishlistUrl(list.lid);
    if (!shareUrl) {
      var elements = getShareModalElements();
      if (elements.error) {
        elements.error.textContent = 'Shared wishlist page URL is not configured.';
        elements.error.hidden = false;
      }
      openShareListModal('', false);
      return;
    }
    var wasPrivate = !isListPublic(list);
    openShareListModal(shareUrl, wasPrivate);
    if (!wasPrivate) {
      return;
    }
    /*
     * Private -> Public happens asynchronously.
     * Popup is NOT blocked by this request.
     */
    markListPublicOnSwym(list)
      .then(function () {
        return updateListPublicStatus(list, true);
      })
      .then(function () {
        updateWishlistDrawerHeading(currentDrawerList);
      })
      .catch(function (error) {
        showShareListError(error);
      });
  }
  function bindShareListModalEvents() {
    var elements = getShareModalElements();
    if (!elements.modal) {
      return;
    }
    if (elements.modal.dataset.bound === 'true') {
      return;
    }
    elements.modal.dataset.bound = 'true';
    elements.close?.addEventListener('click',
      function () {
        closeShareListModal();
      }
    );
    elements.overlay?.addEventListener('click',
      function () {
        closeShareListModal();
      }
    );
    elements.copy?.addEventListener('click',
      function () {
        copyShareListUrl();
      }
    );
    elements.url?.addEventListener('click',
      function () {
        copyShareListUrl();
      }
    );
    document.addEventListener('keydown',
      function (event) {
        if (event.key === 'Escape' && !elements.modal.hidden) {
          closeShareListModal();
        }
      }
    );
  }
  function showSharedWishlistUnavailable(loading, content, unavailable) {
    if (loading) {
      loading.hidden = true;
    }
    if (content) {
      content.hidden = true;
    }
    if (unavailable) {
      unavailable.hidden = false;
    }
  }
  // Wishlist header icon count
  function initHeaderIconCount(swat) {
    var countEls = document.querySelectorAll('.js-header-wishlist-item-count');
    if (!countEls.length) {
      return;
    }
    updateCount(swat);
    if (swat.evtLayer) {
      swat.evtLayer.addEventListener('sw:addedtowishlist', function () {
        updateCount(swat);
      });
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function () {
        updateCount(swat);
      });
    }
  }
  function updateCount(swat) {
    swat.fetch(function (products) {
      var count = products ? products.length : 0;
      var countEls = document.querySelectorAll('.js-header-wishlist-item-count');
      var countWrappers = document.querySelectorAll('.js-header-wishlist-wrapper');
      countEls.forEach(function (countEl) {
        countEl.textContent = count;
      });
      countWrappers.forEach(function (countWrapper) {
        countWrapper.setAttribute('data-wishlist-count', count);
      });
    });
  }
  // wishlist header icon state
  function initHeaderIcon(swat) {
    var wishlistEl = document.querySelectorAll('.header-brand-tabs__icon--wishlist, .header__icon--wishlist');
    if (!wishlistEl.length) {
      return;
    }
    updateHeaderWishlistState(swat);
    if (swat.evtLayer) {
      swat.evtLayer.addEventListener('sw:addedtowishlist', function () {
        updateHeaderWishlistState(swat);
      });
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function () {
        updateHeaderWishlistState(swat);
      });
    }
  }
  function updateHeaderWishlistState(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') {
      return;
    }
    swat.fetchLists({
      callbackFn: function (lists) {
        var hasWishlistItem = (lists || []).some(function (list) {
          return Number(list.cnt || 0) > 0;
        });
        document.querySelectorAll('.header-brand-tabs__icon--wishlist, .header__icon--wishlist').forEach(function (item) {
          var defaultIcon = item.querySelector('.wishlist-icon-default');
          var filledIcon = item.querySelector('.wishlist-icon-filled');
          if (!defaultIcon || !filledIcon) {
            return;
          }
          defaultIcon.hidden = hasWishlistItem;
          filledIcon.hidden = !hasWishlistItem;
        });
      },
      errorFn: function (error) {
        console.error('[Wishlist] Failed to fetch lists:', error);
      }
    });
  }
  function formatPrice(price) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(Number(price) / 100);
  }
  function equalizeWishlistCardHeights() {
    var grids = [document.getElementById('swym-wishlist-drawer-grid'), document.getElementById('swym-shared-wishlist-grid')].filter(Boolean);
    if (!grids.length) {
      return;
    }
    var selectors = [
      '.product-card__title',
      '.product-card__price',
      '.product-promotion-message-block',
      '.ms-wishlist-card__variant-details'
    ];
    grids.forEach(function (grid) {
      selectors.forEach(function (selector) {
        grid.querySelectorAll(selector).forEach(function (element) {
          element.style.height = 'auto';
        });
      });
      var cards = Array.from(grid.children);
      if (!cards.length) {
        return;
      }
      var rows = [];
      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        var row = rows.find(function (existingRow) {
          return Math.abs(existingRow.top - rect.top) <= 1;
        });
        if (row) {
          row.cards.push(card);
        } else {
          rows.push({
            top: rect.top,
            cards: [card]
          });
        }
      });
      rows.forEach(function (row) {
        selectors.forEach(function (selector) {
          var elements = [];
          row.cards.forEach(function (card) {
            var element = card.querySelector(selector);
            if (element) {
              elements.push(element);
            }
          });
          if (!elements.length) {
            return;
          }
          var maxHeight = 0;
          elements.forEach(function (element) {
            var height = element.getBoundingClientRect().height;
            if (height > maxHeight) {
              maxHeight = height;
            }
          });
          elements.forEach(function (element) {
            element.style.height = maxHeight + 'px';
          });
        });
      });
    });
  }
  window.addEventListener('resize', function () {
    equalizeWishlistCardHeights();
  });
  function initWishlistMediaCarousel(context) {
    const elements = getWishlistElements(context);

    if (!elements.media) {
      return;
    }

    const sliderEl = elements.media.querySelector(".js-quick-view-slider");
    const sliderThumbnailsEl = elements.media.querySelector(
      ".js-quick-view-slider-thumbnails"
    );

    if (!sliderEl || !sliderThumbnailsEl) {
      return;
    }

    const Swiper = window.themeCore.utils.Swiper;

    const paginationEl = elements.media.querySelector(
      ".js-quick-view-slider-pagination"
    );

    const prevButton = elements.media.querySelector(
      ".js-quick-view-slider-prev-btn"
    );

    const nextButton = elements.media.querySelector(
      ".js-quick-view-slider-next-btn"
    );

    const isDynamicBullets =
      sliderEl.getAttribute("data-dynamic-pagination") === "true";

    const sliderThumbnails = new Swiper(sliderThumbnailsEl, {
      slidesPerView: 5,
      spaceBetween: 4,
      freeMode: true,
      watchSlidesProgress: true,
      a11y: {
        slideRole: ""
      },
      threshold: 10,
      breakpoints: {
        1200: {
          spaceBetween: 20
        }
      }
    });

    const slider = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 8,
      autoplay: false,

      pagination: {
        el: paginationEl,
        clickable: true,
        bulletElement: "button",
        dynamicBullets: isDynamicBullets
      },

      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },

      thumbs: {
        swiper: sliderThumbnails
      }
    });

    context._wishlistMediaSlider = slider;

    return {
      slider: slider,
      sliderThumbnails: sliderThumbnails
    };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      const modal = document.getElementById("wishlist-modal");
      if (modal) {
        bindWishlistEvents(modal);
      }
    });
  } else {
    const modal = document.getElementById("wishlist-modal");
    if (modal) {
      bindWishlistEvents(modal);
    }
  }
  function trackKlaviyoEvent(eventName, properties) {
    const wishlistModal = document.getElementById('wishlist-modal');
    const customerEmail = wishlistModal?.dataset.customer || '';
    if (!customerEmail) {
      return;
    }
    const publicApiKey = 'PpVeME';
    fetch(`https://a.klaviyo.com/client/events?company_id=${publicApiKey}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: eventName
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail
                }
              }
            },
            properties: properties,
            unique_id: crypto.randomUUID()
          }
        }
      })
    })
      .then(async response => {
        if (!response.ok) {
          console.error('Klaviyo error:', await response.text());
        }
      })
      .catch(error => {
        console.error(`Klaviyo "${eventName}" failed:`, error);
      });
  }
  function trackAmplitudeEvent(eventName, properties) {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish(eventName, properties);
    } else {
      console.warn("Amplitude: Shopify Analytics Publish API not available");
    }
  }
})();
document.addEventListener('click', function (event) {
  const heart = event.target.closest('.custom-wishlist-button-logged-out');
  if (!heart) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  const headerWishlistEl = document.querySelector('.header-brand-tabs__icon--wishlist, .header__icon--wishlist');
  if (!headerWishlistEl) {
    console.warn('Header wishlist element not found');
    return;
  }
  const wishlistUrl = headerWishlistEl.href;
  if (!wishlistUrl) {
    console.warn('Header wishlist href not found');
    return;
  }
  window.location.href = wishlistUrl;
});